var _defs, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatures(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 551.04 583.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e4e7f2;\n      }\n\n      .cls-2, .cls-3 {\n        fill: #3e7eff;\n      }\n\n      .cls-4 {\n        fill: #e0e0e0;\n      }\n\n      .cls-5 {\n        fill: #2443ac;\n      }\n\n      .cls-6, .cls-7, .cls-8, .cls-3, .cls-9, .cls-10 {\n        isolation: isolate;\n      }\n\n      .cls-6, .cls-3 {\n        opacity: .1;\n      }\n\n      .cls-7 {\n        opacity: .15;\n      }\n\n      .cls-8 {\n        opacity: .05;\n      }\n\n      .cls-11 {\n        fill: #5900cc;\n      }\n\n      .cls-12 {\n        fill: #394051;\n      }\n\n      .cls-13 {\n        fill: #ffbe9d;\n      }\n\n      .cls-14 {\n        fill: #ebebeb;\n      }\n\n      .cls-15 {\n        fill: #f4f4f4;\n      }\n\n      .cls-16 {\n        fill: #fe8163;\n      }\n\n      .cls-17 {\n        fill: #f5f7fc;\n      }\n\n      .cls-18 {\n        fill: #ced5e5;\n      }\n\n      .cls-19, .cls-9, .cls-10 {\n        fill: #d6d8e5;\n      }\n\n      .cls-20 {\n        fill: #263238;\n      }\n\n      .cls-21 {\n        fill: #e5e5e5;\n      }\n\n      .cls-22 {\n        fill: #eb996e;\n      }\n\n      .cls-23 {\n        fill: #ff4d4d;\n      }\n\n      .cls-24 {\n        fill: #232733;\n      }\n\n      .cls-25 {\n        fill: #cc8b09;\n      }\n\n      .cls-26 {\n        fill: #f9cb07;\n      }\n\n      .cls-27 {\n        fill: #37b37f;\n      }\n\n      .cls-28 {\n        stroke: #f1f2f7;\n      }\n\n      .cls-28, .cls-29, .cls-30 {\n        fill: none;\n        stroke-width: 3px;\n      }\n\n      .cls-29 {\n        stroke: #ed85c3;\n      }\n\n      .cls-29, .cls-30 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-31 {\n        fill: #ffcea9;\n      }\n\n      .cls-32 {\n        fill: #fff;\n      }\n\n      .cls-30 {\n        stroke: #52cb96;\n      }\n\n      .cls-33 {\n        fill: #f9ca06;\n      }\n\n      .cls-34 {\n        fill: #dd990e;\n      }\n\n      .cls-35 {\n        fill: #fafafa;\n      }\n\n      .cls-36 {\n        fill: #1d3892;\n      }\n\n      .cls-37 {\n        opacity: .8;\n      }\n\n      .cls-38 {\n        opacity: .2;\n      }\n\n      .cls-39, .cls-9 {\n        opacity: .3;\n      }\n\n      .cls-40 {\n        fill: #9c73ff;\n      }\n\n      .cls-41 {\n        fill: #2f55d4;\n      }\n\n      .cls-42 {\n        fill: #d33d3d;\n      }\n\n      .cls-43 {\n        fill: #e8a30a;\n      }\n\n      .cls-44 {\n        fill: #f5f5f5;\n      }\n\n      .cls-45 {\n        fill: #bfbfbf;\n      }\n\n      .cls-46 {\n        fill: #b7e200;\n      }\n\n      .cls-47 {\n        fill: #b1b4c4;\n      }\n\n      .cls-48 {\n        fill: #2b303f;\n      }\n\n      .cls-49 {\n        fill: #9ea1af;\n      }\n\n      .cls-50 {\n        fill: #283444;\n      }\n\n      .cls-51 {\n        fill: #e9eaf2;\n      }\n\n      .cls-52 {\n        fill: #ededed;\n      }\n\n      .cls-53 {\n        fill: #455a64;\n      }\n\n      .cls-54 {\n        fill: #ffb3da;\n      }\n\n      .cls-55 {\n        fill: #f1f2f7;\n      }\n\n      .cls-56 {\n        fill: #dadce5;\n      }\n\n      .cls-57 {\n        fill: #ffdfd7;\n      }\n\n      .cls-10 {\n        opacity: .4;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "big-launch"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "cls-55",
    d: "M37.35,97.75c-4.29-36.17,19.34-68.43,51.09-55.01,33.65,14.21,31.1,46.49,46.27,56.97,15.15,10.48,72.01-25.56,101.15,6.34,16.47,18.02,17.14,33.27,6.91,54.06-7.25,14.73-27.6,39-77.68,39-35.84,0-46.16,19.43-72.85,44.4-34.53,32.29-55.59,12.35-43.16-40.18,11.68-49.41-5.21-50.39-11.74-105.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    className: "cls-27",
    d: "M138.23,142.02s-25.74-3.07-31.79-1.59,9.94,47.58,9.94,47.58l7.96-3.14-6.56-30.96s16.31,8.54,32.84,6.19c0,0-.12-13.47-12.39-18.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    className: "cls-50",
    d: "M190.86,212.84l6.68,1.05s1.78,9.7-1.39,16.32c-3.17,6.62-6.85,9.8-11.1,11.09l-4.37-8.35,10.17-20.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    className: "cls-32",
    d: "M104.99,155.79c7.96-14.29,8.39-25.62,8.4-26.86,1.19,1.07,1.77,1.7,1.77,1.7l76.46,76.41c3.36,28.98-17.22,33.29-17.22,33.29,0,0-57.99-36.99-88.9-69.05,1.17-.09,11.54-1.24,19.49-15.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    "data-name": "Path",
    className: "cls-28",
    d: "M187.95,203.36l3.67,3.66c3.36,28.98-17.22,33.29-17.22,33.29,0,0-1.66-1.05-4.58-2.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    "data-name": "Path",
    className: "cls-16",
    d: "M52.44,105.09c35.26,3.05,55.19,18.63,60.96,23.84-.03,1.24-.46,12.57-8.4,26.86-7.95,14.27-18.32,15.4-19.5,15.49-.02-.02-.05-.04-.06-.07-30.91-32.09-32.99-66.12-32.99-66.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-7",
    "data-name": "Path",
    className: "cls-5",
    points: "212.93 204.08 212.23 201.35 180.23 166.77 150.03 165.47 155.64 171.46 212.93 204.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-8",
    "data-name": "Path",
    className: "cls-57",
    points: "123.66 189.74 124.74 196.52 120.95 197.91 118.19 190.57 123.66 189.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-9",
    "data-name": "Path",
    className: "cls-5",
    points: "179.55 259.11 178.85 260.18 138.49 238.33 124.11 204.84 131 209.15 179.55 259.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-10",
    "data-name": "Path",
    className: "cls-41",
    d: "M212.93,204.08l-32.5-34.12-24.77,1.5,32.34,31.85s8.43-3.29,24.94.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-11",
    "data-name": "Path",
    className: "cls-41",
    d: "M169.22,236.32s4.34,14.01,10.32,22.79l-39.25-21.63-9.3-28.34,38.23,27.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-12",
    "data-name": "Path",
    className: "cls-5",
    points: "189.58 242.38 188.62 243.69 154.62 216.1 138.81 199.2 143.91 192.85 189.58 242.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-13",
    "data-name": "Path",
    className: "cls-41",
    d: "M178.24,221.33s7.63,11.37,11.34,21.05l-33.63-27.98-12.06-21.53,34.35,28.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-14",
    "data-name": "Path",
    className: "cls-27",
    d: "M150.62,160.09s-1.84,3.36-31.33,1.11c0,0,4.66,20.22,6.18,29.96l-10.38,2.77s-9.1-33.47-9.07-38.02c.03-4.55,2.83-6.3,10.31-8.67,7.48-2.37,21.53-5.12,21.53-5.12,0,0,9.27,2.74,11.25,7.62,1.96,4.9,1.52,10.35,1.52,10.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-15",
    "data-name": "Path",
    className: "cls-57",
    points: "165.16 111.17 165.42 105.44 163.03 105.46 160.79 110.13 165.16 111.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-16",
    "data-name": "Path",
    className: "cls-57",
    d: "M165.37,106.57s4.05-1.53,5.94-7.49c1.9-5.95-2.68-9.61-6.12-8.58s-6.23,10.28-6.47,11.42c-.24,1.16-1.89,6.4,6.65,4.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-17",
    "data-name": "Path",
    className: "cls-11",
    d: "M162.86,92.41s-.27-3.27,4.13-3.99c4.38-.72,6.04,8.11,11.34,10.22,5.28,2.11,10.37,1.7,14.49,6.38,4.13,4.66,4.6,9.74,4.46,14.08-.12,4.34-3.4.85-4.57,4.9-1.17,4.05-4.52,1.92-5.18,3.53-.65,1.61-4.25,9.19-6.46,4.34-2.21-4.84-2.1-9.63-6.91-12.22-3.5-1.87-7.41-8.3-8.78-13.09-.52-1.81-.17-3.66-.03-4.55.5-3.11.9-5.29.27-6.99-.4-1.02-.81-1.96-2.77-2.62Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-18",
    "data-name": "Path",
    className: "cls-57",
    points: "143.46 97.49 141.44 77.84 144.51 76.68 148.29 94 154.73 114.7 149.28 121.41 143.46 97.49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-19",
    "data-name": "Path",
    className: "cls-54",
    d: "M156.44,113.42s-4.46-10.28-7.75-19.44c0,0-1.46,2.18-5.63,3.64l5.28,25.03,8.1-9.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-20",
    "data-name": "Path",
    className: "cls-11",
    d: "M124.74,196.52l2.07,4.77-12.36,5.82s-.73-2.61,6.5-9.2l3.79-1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-21",
    "data-name": "Path",
    className: "cls-57",
    d: "M114.46,136.34s-2.86-2.46-4.38-3.09c-1.52-.63,1.02,2.53,1.02,2.53,0,0-3.33,0-5.25.46-1.92.46.32,5.66,1.87,5.88,1.55.2,7.72-2.01,7.72-2.01,0,0,1.19-2.66-.97-3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-22",
    "data-name": "Path",
    className: "cls-57",
    d: "M144.51,76.68s1.77-2.7,1.92-3.59c.14-.89-.72-.31-1.61.72,0,0,.85-4.92.49-5.56-.37-.65-3.44-1.46-3.99,1.94-.32,1.98.11,7.65.11,7.65,0,0,2.38,1.18,3.09-1.16Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Path-23",
    "data-name": "Path",
    className: "cls-30",
    x1: 128.64,
    y1: 144.1,
    x2: 137.85,
    y2: 142.15
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-24",
    "data-name": "Path",
    className: "cls-57",
    points: "135.52 138.17 115.44 140.13 114.46 136.34 133.66 131.48 147.22 122.39 151.56 128.41 135.52 138.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-25",
    "data-name": "Path",
    className: "cls-54",
    d: "M165.39,114.59s-8.82,36.82-14.65,46.01c0,0-1.28-7.67-13.32-18.85,0,0,8.86-19.83,18.25-28.19,9.38-8.34,10.34-1.5,9.71,1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-26",
    "data-name": "Path",
    className: "cls-54",
    d: "M149.65,120.21s-11.57,8.37-16.4,10.72c0,0,1.46,5.25,1.67,8.5l7.48-3.49,6.04-10.59,1.2-5.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-27",
    "data-name": "Path",
    className: "cls-29",
    d: "M157.5,112.02s-4.45,3.01-7.86,8.17c0,0-7.28,5.25-10.9,7.49-3.64,2.24-5.5,3.23-5.5,3.23,0,0,.94,2.81,1.67,8.5l11.53-5.45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-28",
    "data-name": "Path",
    className: "cls-18",
    d: "M84.71,73.35c-3.09-6.06-9.2-9.33-14.51-9.48-7.75-.22-9.36,6.52-14.19,4.84-5.82-2.03-4.7-12.29-11.8-15.08-2.5-.98-6.55-1.4-9.56.96-4.45,3.49-4.86,5.95-6.99,8.13-.52.54-1.55,1.5-2.97,2.14-3.04,1.37-5.98.22-7.57-.41-3.9-1.57-3.81-3.44-6.61-4.03-2.3-.48-5.19.18-7.25,2.29C-.42,66.51-.07,73.55.09,76.66c.03.63.08,1.15.12,1.5h86.34c-.5-2.16-1.49-4.12-1.84-4.81Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    className: "cls-41",
    cx: 186.14,
    cy: 42.59,
    rx: 21.76,
    ry: 26.41
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-29",
    "data-name": "Path",
    className: "cls-18",
    d: "M275.71,154.36c-.59-2.16-2.98-10.55-9.99-15.42-8.97-6.23-18.62-1.92-19.2-1.65-10.95,5.12-13.03,19.02-19.67,18.11-3.87-.52-3.85-5.34-9.01-6.82-5.48-1.57-12.47,1.85-15.32,8.11-1.31,2.88-1.67,6.23-1.46,9.19h75.94c.2-3.9-.38-8.15-1.29-11.53Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1-2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "monitor"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M466.19,186.46l-27.52-15.44c-1.98-1.11-1.73-3.05.55-4.33l17.83-9.99,34.71,19.44-17.83,9.99c-2.28,1.3-5.75,1.44-7.73.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M468.67,185.04l-27.52-15.41c-1.99-1.11-1.73-3.05.55-4.33l17.83-9.99,34.71,19.44-17.83,9.98c-2.29,1.29-5.76,1.43-7.74.31Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "494.25 174.74 494.25 173.73 492.64 174.62 494.25 174.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "439.81 167.79 439.81 166.76 441.46 167.42 439.81 167.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M468.67,184.02l-27.52-15.41c-1.99-1.11-1.73-3.06.55-4.34l17.83-9.98,34.71,19.44-17.83,9.98c-2.28,1.28-5.75,1.43-7.74.31Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "459.63 154.33 455.33 140.51 490.42 160.03 494.25 173.73 459.63 154.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M493.23,174.3l1.02-.57-1.51-1.17.49,1.74Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "458.52 154.86 454.23 141.03 489.32 160.55 493.23 174.3 458.52 154.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M547.59,197.59l-135.81-76.06c-1.9-1.06-3.45-3.93-3.45-6.39V13.24c0-2.46,1.54-3.6,3.45-2.53l135.81,76.06c1.91,1.06,3.45,3.93,3.45,6.39v101.91c0,2.46-1.54,3.59-3.45,2.53Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "548.29 198.64 549.79 197.8 549.14 193.47 548.29 198.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M408.09,11.34l1.48-.83,2.13,1.2s-2.27.34-2.32.32-1.29-.69-1.29-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M546.35,198.29l-135.81-76.06c-1.9-1.06-3.45-3.93-3.45-6.39V13.93c0-2.46,1.54-3.6,3.45-2.53l135.81,76.06c1.9,1.06,3.45,3.93,3.45,6.39v101.91c0,2.46-1.54,3.59-3.45,2.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M549.56,93.99v101.92c0,2.47-1.55,3.6-3.45,2.53l-135.81-76.07c-1.9-1.06-3.45-3.93-3.45-6.39V14.07c0-2.46,1.54-3.59,3.45-2.53l135.81,76.06c1.9,1.06,3.45,3.93,3.45,6.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M547.67,192.23l-139.1-77.91.08-99.84c0-1.03.74-1.44,1.65-.93l135.81,76.06c.97.62,1.58,1.65,1.65,2.78l-.08,99.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M539.07,105.43l-123.31-69.07c-.87-.6-1.39-1.56-1.4-2.6v-8.64c0-1,.63-1.46,1.4-1.03l123.31,69.05c.87.6,1.39,1.57,1.4,2.6v8.64c0,1.01-.63,1.47-1.4,1.04Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-56",
    cx: 420,
    cy: 32.58,
    rx: 2.19,
    ry: 3.73,
    transform: "translate(45.04 224.58) rotate(-31.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M484.11,69.63l-10.66-5.98c-.22-.15-.35-.39-.35-.65v-1.37c0-.26.15-.37.35-.26l10.66,5.98c.22.15.35.39.35.65v1.37c0,.25-.15.37-.35.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M501.38,79.32l-10.66-5.97c-.22-.15-.35-.39-.35-.65v-1.37c0-.25.15-.37.35-.26l10.66,5.97c.22.15.35.39.35.65v1.37c0,.26-.16.34-.35.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M518.37,88.81l-10.67-5.97c-.22-.15-.35-.4-.35-.65v-1.37c0-.25.16-.37.35-.26l10.67,5.98c.22.15.35.39.35.65v1.37c0,.26-.14.35-.35.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M535.63,98.48l-10.67-5.97c-.22-.15-.35-.39-.35-.65v-1.36c0-.25.16-.37.35-.26l10.67,5.97c.22.15.35.39.35.65v1.37c0,.24-.16.35-.35.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M529.74,126.87l-28.99-16.24c-.85-.6-1.36-1.55-1.38-2.57v-18.18c0-1,.63-1.46,1.4-1.03l28.99,16.23c.87.6,1.39,1.57,1.4,2.6v18.14c-.02,1.01-.65,1.46-1.43,1.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M491.56,132.77l-72.71-40.73c-.43-.3-.69-.78-.7-1.3v-3.13c0-.5.32-.73.7-.53l72.71,40.72c.43.3.69.78.7,1.3v3.13c-.02.52-.31.75-.7.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M484.4,136.15l-65.34-36.6c-.43-.3-.69-.78-.7-1.3v-1.55c0-.5.31-.73.7-.53l65.34,36.6c.43.3.69.78.7,1.3v1.55c0,.52-.32.76-.7.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M484.4,142.04l-65.34-36.59c-.43-.3-.69-.79-.7-1.3v-1.55c0-.5.31-.73.7-.53l65.34,36.59c.43.3.69.79.7,1.3v1.55c0,.52-.32.75-.7.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M467.69,138.59l-48.64-27.24c-.43-.3-.69-.78-.7-1.3v-1.55c0-.5.31-.73.7-.53l48.64,27.26c.44.3.7.78.7,1.3v1.55c0,.5-.31.73-.7.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M530.44,134.42l-30.39-17.04c-.43-.3-.69-.78-.7-1.3v-1.55c0-.5.31-.73.7-.53l30.39,17.04c.43.3.7.79.7,1.3v1.55c0,.52-.31.75-.7.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M530.44,140.32l-30.39-17.04c-.43-.3-.7-.79-.7-1.3v-1.55c0-.5.31-.73.7-.53l30.39,17.04c.43.3.69.78.7,1.3v1.55c0,.52-.31.76-.7.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M522.48,141.75l-22.43-12.56c-.43-.3-.69-.78-.7-1.3v-1.55c0-.5.31-.73.7-.53l22.43,12.61c.43.3.7.79.7,1.3v1.55c0,.48-.31.71-.7.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M529.74,172.31l-28.99-16.24c-.86-.61-1.37-1.57-1.38-2.6v-18.15c0-1,.63-1.46,1.4-1.03l28.99,16.23c.87.6,1.39,1.57,1.4,2.6v18.14c-.02,1.01-.65,1.46-1.43,1.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M530.44,179.86l-30.39-17.04c-.43-.3-.69-.78-.7-1.3v-1.55c0-.5.31-.73.7-.53l30.39,17.04c.43.3.7.79.7,1.3v1.55c0,.52-.31.75-.7.53Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "509.21 107.34 507.17 102.25 503.47 107.36 507.53 109.64 510.88 111.51 518.33 115.69 512.93 102.19 509.21 107.34"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-56",
    cx: 524.22,
    cy: 107.57,
    rx: 1.97,
    ry: 3.36,
    transform: "translate(21.19 290.17) rotate(-31.55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "509.42 153.44 507.38 148.36 503.68 153.47 507.75 155.75 511.09 157.62 518.54 161.79 513.14 148.3 509.42 153.44"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-56",
    cx: 525.33,
    cy: 154.29,
    rx: 1.97,
    ry: 3.37,
    transform: "translate(-3.38 296.57) rotate(-31.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M490.72,119.57l-70.45-39.26c-.78-.54-1.25-1.4-1.26-2.33v-31.84c0-.89.55-1.31,1.26-.92l70.45,39.26c.78.54,1.24,1.41,1.26,2.33v31.84c0,.9-.57,1.31-1.26.92Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "439.84 79.48 436.36 70.78 430.03 79.52 436.98 83.42 442.7 86.62 455.44 93.75 446.21 70.68 439.84 79.48"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-56",
    cx: 478.46,
    cy: 88.93,
    rx: 3.36,
    ry: 5.74,
    transform: "translate(24.19 263.5) rotate(-31.55)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M422.8,68.67v47.7c0,1.78-1.1,2.6-2.49,1.83l-13.46-7.52v-54.14l13.46,7.53c1.37.77,2.49,2.84,2.49,4.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M409.95,52.51l-41.36-23.16c-.43-.29-.97-.36-1.47-.2h0c-.11.04-.22.1-.31.18l-1.3.73.6.78v48.04c0,1.78,1.1,3.84,2.49,4.62l40.57,22.73.52,1.6,1.77-.96c.09-.04.17-.09.25-.14h0c.53-.48.8-1.17.73-1.87v-47.7c-.02-1.77-1.13-3.85-2.51-4.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M408.22,107.6l-41.36-23.16c-1.37-.77-2.49-2.84-2.49-4.62v-47.7c0-1.78,1.1-2.6,2.49-1.83l41.36,23.16c1.38.77,2.49,2.84,2.49,4.62v47.7c0,1.76-1.11,2.6-2.49,1.83Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "370.85 81.65 371.84 82.21 371.84 39.78 370.85 39.22 370.85 81.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M371.35,59.41h0c-1.08-.75-1.73-1.95-1.75-3.23v-4.98c0-1.25.78-1.82,1.75-1.28h0c1.08.75,1.72,1.95,1.74,3.23v4.98c0,1.25-.78,1.82-1.74,1.28Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "381.52 87.47 382.52 88.03 382.52 45.61 381.52 45.05 381.52 87.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M382.02,79.19h0c-1.08-.75-1.72-1.95-1.75-3.24v-4.98c0-1.25.78-1.82,1.75-1.28h0c1.08.75,1.72,1.95,1.75,3.23v4.98c0,1.25-.78,1.82-1.75,1.28Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "392.19 93.45 393.19 94.01 393.19 51.58 392.19 51.03 392.19 93.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M392.69,65.63h0c-1.08-.75-1.72-1.95-1.75-3.23v-4.98c0-1.25.78-1.82,1.75-1.28h0c1.08.75,1.72,1.95,1.75,3.24v4.98c0,1.25-.78,1.82-1.75,1.28Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "402.87 99.43 403.86 99.98 403.86 57.56 402.87 57 402.87 99.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M403.37,82.77h0c-1.08-.75-1.73-1.95-1.75-3.23v-4.98c0-1.25.78-1.82,1.75-1.28h0c1.08.75,1.72,1.95,1.74,3.23v4.98c0,1.25-.78,1.82-1.74,1.28Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Coin"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 383.7,
    cy: 152.23,
    rx: 15.26,
    ry: 8.54
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-34",
    cx: 387.48,
    cy: 150.03,
    rx: 15.26,
    ry: 8.54
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "372.23 150.16 372.23 146.27 375.24 148.87 372.23 150.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "402.74 146.37 402.74 150.03 401.19 151.62 400.44 147.43 402.74 146.37"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-26",
    cx: 387.48,
    cy: 146.37,
    rx: 15.26,
    ry: 8.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M398.39,146.64c-.15,1.44-1.21,2.86-3.18,3.96-4.27,2.39-11.19,2.39-15.45,0-1.97-1.1-3.02-2.52-3.18-3.96-.18-1.68.88-3.41,3.18-4.69,4.26-2.39,11.18-2.39,15.45,0,2.29,1.28,3.35,3.01,3.18,4.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M398.39,146.64c-.15,1.44-1.21,2.86-3.18,3.96-4.27,2.39-11.19,2.39-15.45,0-1.97-1.1-3.02-2.52-3.18-3.96.15-1.44,1.21-2.86,3.18-3.96,4.26-2.39,11.18-2.39,15.45,0,1.96,1.1,3.02,2.52,3.18,3.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M387.32,144.63c-.13,0-.27,0-.4.03-.18,0-.38.06-.6.11s-.46.1-.7.17c-.23.07-.46.15-.68.26l1.75.98.32-.11c.44-.14.87-.27,1.26-.37.37-.1.75-.16,1.14-.18.35-.02.7,0,1.04.07.35.07.69.2,1,.38.31.15.57.37.76.64.13.2.17.44.11.67-.07.25-.22.48-.41.65-.24.23-.51.44-.8.61l1.1.62-.6.34-1.13-.63c-.53.26-1.08.46-1.65.61-.61.16-1.22.28-1.85.34l-.59-1.02c.17,0,.33-.02.49-.04.25-.03.49-.07.74-.12.27-.05.55-.13.86-.21.29-.08.58-.18.86-.31l-1.75-.97-.23.07-.24.07c-.4.13-.8.24-1.21.33-.34.08-.68.12-1.03.13-.31.01-.61-.01-.91-.08-.3-.07-.58-.18-.84-.33-.29-.15-.54-.35-.73-.61-.14-.19-.21-.42-.2-.66.03-.24.12-.47.29-.66.21-.24.45-.45.71-.62l-1.04-.58.61-.34,1.03.57c.48-.23.98-.41,1.5-.53.5-.12,1-.21,1.51-.27l.51.98ZM384.34,146.4c.23.13.49.18.76.16.36-.04.71-.12,1.05-.23l-1.65-.92c-.6.4-.65.73-.16.99ZM390.1,146.86c-.25-.13-.54-.18-.82-.14-.39.05-.77.13-1.15.24l1.65.91c.68-.39.79-.73.32-1v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M386.38,148.81v-.57l.67.42-.29.43-.38-.28Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "392.21 149.17 392.21 148.59 390.77 148.71 391.6 149.25 392.21 149.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "392.34 147.07 392.34 146.49 391.25 146.86 392.34 147.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M387.84,147.03l.36-.34,1.27.85-.08.26s-.95-.39-.99-.42l-.57-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M384.5,145.22l1.69.93.35-.24s-.21-.23-.23-.26c-.16-.17-.35-.31-.55-.43-.13,0-.93-.37-.93-.37l-.33.37Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "387.32 144.63 387.32 144.06 386.54 143.81 386.38 144.27 386.42 144.47 387.32 144.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "382.15 144.22 382.15 143.64 383.05 143.74 382.76 144.29 382.15 144.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M382.19,146.17v-.6h1.04l-.25.53-.45.48-.33-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M387.32,144.06c-.13,0-.27,0-.4.03-.18.03-.38.06-.6.11s-.46.1-.7.17c-.23.07-.46.15-.68.26l1.75.98.32-.11c.44-.14.87-.27,1.26-.37.37-.1.75-.16,1.14-.18.35-.02.7,0,1.04.07.35.07.69.2,1,.38.31.15.57.37.76.64.13.2.17.44.11.67-.07.25-.22.48-.41.65-.24.23-.51.44-.8.61l1.1.63-.6.34-1.13-.63c-.53.26-1.08.46-1.65.61-.61.16-1.22.28-1.85.34l-.59-1.02c.17,0,.33-.02.49-.04.25-.03.49-.07.74-.12.27-.05.55-.13.86-.21.29-.08.58-.18.86-.31l-1.75-.97-.23.07-.24.07c-.4.13-.8.24-1.21.33-.34.08-.68.12-1.03.13-.31.01-.61-.01-.91-.08-.3-.07-.58-.18-.84-.33-.29-.15-.54-.35-.73-.61-.14-.19-.21-.42-.2-.65.02-.24.12-.48.29-.67.21-.24.45-.45.71-.62l-1.04-.58.61-.34,1.03.57c.48-.23.98-.41,1.5-.53.5-.12,1-.21,1.51-.26l.51.97ZM384.34,145.86c.23.13.49.18.76.16.36-.04.71-.12,1.05-.23l-1.65-.92c-.6.36-.65.69-.16.99ZM390.1,146.33c-.25-.13-.54-.18-.82-.14-.39.05-.77.13-1.15.24l1.65.92c.68-.42.79-.78.32-1.04v.02Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Coin-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-34",
    cx: 388.72,
    cy: 145.47,
    rx: 15.26,
    ry: 8.54
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "373.47 145.6 373.47 141.71 376.49 144.31 373.47 145.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "403.98 141.81 403.98 145.47 402.44 147.06 401.69 142.87 403.98 141.81"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-26",
    cx: 388.72,
    cy: 141.81,
    rx: 15.26,
    ry: 8.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M399.63,142.08c-.15,1.44-1.21,2.86-3.18,3.96-4.27,2.39-11.19,2.39-15.45,0-1.97-1.1-3.02-2.52-3.18-3.96-.18-1.68.88-3.41,3.18-4.69,4.26-2.39,11.18-2.39,15.45,0,2.3,1.28,3.36,3.01,3.18,4.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M399.63,142.08c-.15,1.44-1.21,2.86-3.18,3.96-4.27,2.39-11.19,2.39-15.45,0-1.97-1.1-3.02-2.52-3.18-3.96.15-1.44,1.21-2.86,3.18-3.96,4.26-2.39,11.18-2.39,15.45,0,1.96,1.1,3.03,2.52,3.18,3.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M388.56,140.08c-.13,0-.27,0-.4.03-.18,0-.38.06-.6.11s-.46.1-.69.17c-.24.07-.47.15-.69.26l1.78.96.31-.11c.44-.14.87-.27,1.26-.37.37-.1.75-.16,1.14-.18.35-.02.7,0,1.04.07.35.07.69.2,1,.38.31.15.57.37.76.64.13.2.17.44.11.67-.07.25-.22.48-.41.65-.24.23-.51.44-.8.61l1.1.62-.61.34-1.1-.63c-.54.26-1.1.46-1.67.61-.61.16-1.22.28-1.85.34l-.61-.99c.17,0,.33-.02.49-.04.25-.03.49-.07.74-.12.27-.05.55-.13.86-.21.29-.08.58-.18.86-.31l-1.75-.97-.23.07-.24.07c-.4.13-.8.24-1.21.33-.34.08-.68.12-1.03.13-.31.01-.61-.01-.91-.08-.29-.07-.58-.18-.84-.33-.29-.15-.54-.35-.73-.61-.14-.19-.21-.42-.2-.65.03-.24.13-.48.29-.67.2-.24.44-.45.71-.62l-1.03-.58.6-.34,1.03.57c.48-.23.98-.41,1.5-.53.5-.12,1-.21,1.51-.27l.52.96ZM385.58,141.86c.23.13.49.18.76.16.36-.04.71-.12,1.05-.23l-1.65-.92c-.6.38-.65.73-.16.99h0ZM391.34,142.32c-.25-.13-.54-.18-.82-.14-.39.05-.77.13-1.15.24l1.65.91c.68-.41.78-.75.32-1.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M387.62,144.27v-.57l.67.42-.29.43-.38-.28Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "393.47 144.61 393.47 144.04 392.01 144.15 392.85 144.7 393.47 144.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "393.59 142.51 393.59 141.93 392.5 142.31 393.59 142.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M389.09,142.48l.36-.34,1.27.85-.08.26s-.95-.39-.98-.42l-.58-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M385.77,140.67l1.7.93.35-.24-.23-.26c-.16-.17-.34-.32-.55-.43-.13,0-.93-.37-.93-.37l-.33.37Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "388.56 140.08 388.56 139.5 387.79 139.26 387.62 139.71 387.66 139.91 388.56 140.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "383.4 139.66 383.4 139.09 384.31 139.18 384.02 139.74 383.4 139.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M383.44,141.6v-.6h1.03l-.25.53-.45.48-.33-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M388.56,139.5c-.13,0-.27,0-.4.03-.18.03-.38.06-.6.11s-.46.1-.69.17c-.24.07-.47.15-.69.26l1.78,1.01.31-.11c.44-.14.87-.27,1.26-.37.37-.1.75-.16,1.14-.18.35-.02.7,0,1.04.07.35.07.69.2,1,.38.31.15.57.37.76.64.13.2.17.44.11.67-.07.25-.22.48-.41.65-.25.23-.52.42-.82.59l1.1.63-.61.34-1.1-.63c-.54.26-1.1.46-1.67.61-.61.16-1.22.28-1.85.34l-.59-1.02c.17,0,.33-.02.49-.04.25-.03.49-.07.74-.12.27-.05.55-.13.86-.21.29-.08.58-.18.86-.31l-1.75-.97-.23.07-.24.07c-.44.14-.84.24-1.21.32-.34.08-.68.12-1.03.14-.31,0-.61-.02-.91-.09-.29-.07-.58-.18-.84-.33-.29-.14-.54-.35-.73-.61-.14-.19-.21-.42-.2-.65.03-.24.13-.48.29-.67.2-.24.44-.45.71-.62l-1.03-.58.6-.34,1.03.57c.48-.23.98-.41,1.5-.53.5-.12,1-.21,1.51-.26l.5.97ZM385.58,141.28c.23.13.49.18.76.16.36-.04.71-.11,1.05-.23l-1.65-.92c-.6.38-.65.71-.16.98h0ZM391.34,141.75c-.25-.13-.54-.19-.82-.14-.39.05-.77.13-1.15.24l1.65.92c.68-.42.78-.76.32-1.02h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Coin-3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-34",
    cx: 387.79,
    cy: 141.09,
    rx: 15.26,
    ry: 8.54
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "372.53 141.22 372.53 137.32 375.55 139.93 372.53 141.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "403.05 137.43 403.05 141.09 401.51 142.67 400.75 138.48 403.05 137.43"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-26",
    cx: 387.79,
    cy: 137.43,
    rx: 15.26,
    ry: 8.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M398.69,137.69c-.15,1.44-1.21,2.86-3.18,3.96-4.26,2.39-11.18,2.39-15.45,0-1.96-1.1-3.02-2.52-3.17-3.96-.19-1.68.87-3.41,3.17-4.69,4.27-2.39,11.19-2.39,15.45,0,2.33,1.28,3.36,3.01,3.18,4.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M398.69,137.69c-.15,1.44-1.21,2.86-3.18,3.96-4.26,2.39-11.18,2.39-15.45,0-1.96-1.1-3.02-2.52-3.17-3.96.15-1.44,1.21-2.86,3.17-3.96,4.27-2.39,11.19-2.39,15.45,0,1.97,1.1,3.02,2.55,3.18,3.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M387.63,135.69c-.13,0-.27,0-.4.03-.18,0-.38.06-.6.11s-.46.1-.7.17c-.24.07-.46.15-.69.26l1.76.98.31-.11c.45-.14.87-.27,1.26-.37.37-.1.75-.16,1.14-.18.35-.02.7,0,1.05.07.35.07.69.2,1,.38.3.15.56.37.75.64.13.2.17.44.12.67-.08.25-.22.47-.41.65-.24.23-.51.44-.8.61l1.1.62-.61.34-1.13-.63c-.53.26-1.08.46-1.65.61-.6.16-1.22.28-1.84.34l-.59-1.02c.16,0,.33-.02.49-.04.25-.03.49-.07.74-.12.27-.05.55-.13.86-.21.29-.08.58-.19.86-.31l-1.75-.97-.23.07-.24.07c-.4.13-.8.24-1.21.33-.34.08-.68.12-1.03.13-.3.01-.61-.01-.91-.08-.3-.07-.58-.18-.84-.33-.29-.15-.54-.35-.73-.61-.14-.19-.22-.42-.2-.65.03-.24.13-.48.29-.67.2-.24.44-.45.71-.62l-1.04-.58.61-.34,1.03.57c.48-.23.98-.41,1.5-.53.49-.12,1-.21,1.5-.27l.52.98ZM384.67,137.47c.23.13.5.18.76.16.36-.04.7-.12,1.04-.23l-1.65-.92c-.61.38-.67.71-.16.99ZM390.43,137.94c-.25-.13-.54-.18-.82-.14-.39.05-.77.13-1.15.24l1.65.91c.66-.41.77-.75.3-1.02h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M386.69,139.86v-.57l.67.42-.29.43-.38-.28Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "392.53 140.23 392.53 139.65 391.08 139.76 391.91 140.31 392.53 140.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "392.65 138.12 392.65 137.54 391.56 137.92 392.65 138.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M388.15,138.09l.36-.34,1.28.85-.08.26s-.95-.39-.98-.42l-.58-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M384.82,136.28l1.69.93.35-.24-.23-.26c-.16-.17-.34-.32-.55-.43-.12,0-.93-.37-.93-.37l-.33.37Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "387.63 135.69 387.63 135.11 386.85 134.87 386.69 135.32 386.73 135.52 387.63 135.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "382.47 135.27 382.47 134.7 383.37 134.8 383.08 135.35 382.47 135.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M382.5,137.22v-.6h1.03l-.25.53-.44.48-.33-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M387.63,135.11c-.13,0-.27,0-.4.03-.18,0-.38.06-.6.11s-.46.1-.7.17c-.24.07-.46.15-.69.26l1.76.98.31-.11c.45-.14.87-.27,1.26-.37.37-.1.75-.16,1.14-.18.35-.02.7,0,1.05.07.35.07.69.2,1,.38.3.15.56.37.75.64.13.2.17.44.12.67-.08.25-.22.47-.41.65-.24.23-.51.44-.8.61l1.1.63-.61.34-1.13-.63c-.53.26-1.08.46-1.65.61-.6.16-1.22.28-1.84.34l-.59-1.02c.16,0,.33-.02.49-.04.25-.03.49-.07.74-.12.27-.05.55-.13.86-.21.29-.08.58-.19.86-.31l-1.75-.97-.23.07-.24.07c-.4.13-.8.24-1.21.33-.34.08-.68.12-1.03.13-.3.01-.61-.01-.91-.08-.3-.07-.58-.18-.84-.33-.29-.15-.54-.35-.73-.61-.14-.19-.22-.42-.2-.65.03-.24.13-.48.29-.67.2-.24.44-.45.71-.62l-1.04-.6.61-.34,1.03.57c.48-.23.98-.41,1.5-.53.49-.12,1-.21,1.5-.26l.52.99ZM384.67,136.9c.23.13.5.18.76.16.36-.04.7-.12,1.04-.23l-1.65-.92c-.61.38-.67.71-.16.99ZM390.43,137.37c-.25-.13-.54-.18-.82-.14-.39.05-.77.13-1.15.24l1.65.92c.66-.42.77-.76.3-1.04l.02.02Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M534.66,235.35l-32-17.91c-.86-.49-1.15-1.55-.65-2.39.16-.26.38-.48.65-.63h0c.56-.31,1.24-.31,1.8,0l31.99,17.91c.86.48,1.15,1.55.65,2.39-.2.33-.5.59-.86.73h0c-.52.21-1.1.17-1.59-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M520.85,224.51c-11.45-6.42-20.76-22.06-20.76-34.89s9.33-18.04,20.76-11.63c11.43,6.42,20.78,22.06,20.78,34.89s-9.33,18.04-20.78,11.63ZM520.85,182.16c-9.4-5.27-17.05-.98-17.05,9.55s7.65,23.37,17.05,28.64,17.05.98,17.05-9.53-7.65-23.39-17.05-28.65Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "503.32 178.14 507.13 176.13 506.56 178.66 503.32 178.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M531.99,227.78c.09-.04,4.16-2.25,4.16-2.25l-3.14-.49-1.02,2.74Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 518.2,
    cy: 202.68,
    rx: 15.32,
    ry: 26.14,
    transform: "translate(-29.45 301.1) rotate(-31.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M518.2,225.94c-11.45-6.42-20.77-22.06-20.77-34.89s9.33-18.04,20.77-11.63c11.44,6.42,20.76,22.06,20.76,34.89s-9.31,18.04-20.76,11.63ZM518.2,183.59c-9.4-5.27-17.05-.98-17.05,9.55s7.65,23.38,17.05,28.64,17.05.98,17.05-9.55-7.65-23.38-17.05-28.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M518.2,217.09c-7.1-3.98-12.86-13.67-12.86-21.61s5.77-11.18,12.86-7.2c7.1,3.98,12.86,13.67,12.86,21.61s-5.77,11.18-12.86,7.21ZM518.2,192.44c-5.04-2.83-9.15-.53-9.15,5.12s4.11,12.54,9.15,15.37c5.04,2.83,9.16.55,9.16-5.13s-4.12-12.54-9.16-15.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M518.2,208.38c-2.8-1.6-5.09-5.41-5.09-8.55s2.28-4.42,5.09-2.85c2.8,1.57,5.09,5.4,5.09,8.54s-2.28,4.42-5.09,2.85ZM518.2,201.15c-.76-.43-1.37-.08-1.37.77.05.94.56,1.79,1.37,2.31.76.42,1.37.08,1.37-.77-.05-.94-.56-1.79-1.37-2.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "482.83 222.21 480.92 222.23 487.1 219.68 483.52 221.84 482.83 222.21"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-43",
    cx: 483.3,
    cy: 222.49,
    rx: 0.39,
    ry: 0.67,
    transform: "translate(-44.98 285.72) rotate(-31.54)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-43",
    cx: 518.29,
    cy: 202.86,
    rx: 0.39,
    ry: 0.67,
    transform: "translate(-29.54 301.12) rotate(-31.54)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "484.13 224.88 483.67 223.04 488.64 219.97 488.43 220.4 484.13 224.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M483.67,223.06s34.97-19.62,34.97-19.62l-.64-1.17-35.03,19.63.71,1.16Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Girl_12",
    "data-name": "Girl 12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_",
    "data-name": " \\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 ",
    className: "cls-41",
    d: "M451.44.7c.47-.71,4.03-1.21,5.22,1.73.45,1.12.38,3.97.75,5.76.37,1.79,1.25,2.81,1.57,4.26s-.2,3.89-3.81,4.32-6.38-.8-7.24-1.92-.87-3.49,0-4.76,1.56-2.31,1.54-3.97l1.97-5.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_2",
    "data-name": " \\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 2",
    className: "cls-41",
    d: "M453.82.19s-2.72-.73-4.35.65c-1.09.99-1.53,2.48-1.14,3.88.21.83.65,1.95,1.33,2.01s4.16-6.54,4.16-6.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_3",
    "data-name": " \\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 3",
    className: "cls-31",
    d: "M454.83,7.32s-.18,2.91-.13,3.13,1.18.42,1.5.68-1.65,3.19-2.62,3.64-4.06-.68-4.27-2.16c-.2-1.36.88-2.42,1.29-2.79.28-.01.56-.01.85,0l.09-1.41c1.34-.43,3.3-1.09,3.3-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_4",
    "data-name": " \\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 4",
    className: "cls-31",
    d: "M445.99,22.88c-.85,1.13-1.86,2.15-2.99,3.02-.36.36-.7.75-1.02,1.14-.54.6-1.23,1.05-2.01,1.29-.68.17-.97.13-1.1,0s-.06-.31.23-.42c.48-.14.93-.38,1.32-.69,0,0-.63.29-1.03.42-.35.12-.72.19-1.1.21-.37,0-.76-.42-.47-.53s.55-.14,1.15-.35c.31-.11.6-.25.87-.43-.41.11-.82.19-1.24.24-.35.06-.71.01-1.03-.12-.18-.07-.32-.38.07-.48.51-.05,1.01-.16,1.49-.34.46-.2.75-.42.65-.46s-.36.1-.82.06-.89-.32-.88-.53.1-.11.55-.14c.48-.14.98-.24,1.48-.31.48.02.96-.04,1.43-.17.49-.14,1.59-1.42,2.43-2.59.91-1.31,1.64-2.73,2.15-4.23.5-1.6,1.1-4.63,1.54-5.68s1.17-1.53,1.88-1.55c.83,0,1.18,1.03.96,1.94-.4,1.62-2.24,7.79-4.49,10.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_5",
    "data-name": " \\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 5",
    className: "cls-15",
    d: "M455.24,10.73c.84.12,1.81.56,1.94,1.01.35,1.61.26,3.29-.24,4.86-.73,1.87-1.55,5.25-1.98,6.06-2.17.29-4.39-.13-6.28-1.19,0,0-.18-3.26-.19-4.33-2.71-2.3-.39-5.13,1.91-7.34.28-.02.55-.02.83,0,0,0-2.05,2.36-.63,3.69,3.06-.91,3.67-2.24,4.64-2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_6",
    "data-name": " \\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 6",
    className: "cls-31",
    d: "M449.22,3.72h0c.3-1.87,1.7-3.28,3.68-3.17,2.12.14,3.71,1.92,3.57,3.98-.08,1.13-.68,2.16-1.64,2.8-.07.28-.17.56-.31.82-.71.8-2.58,1.3-3.19,1.31s-.99-.48-1.5-1.28c-1.04-1.68-.78-3.54-.61-4.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M453.52.57c1.39.27,2.54.64,2.92,1.98.26.92.6,2.66.27,3.4l-.2.53-1.69.84s-.79-.63-.55-2.5c0-.25-.09-.5-.24-.71-.11-.18-.18-.37-.23-.56-.2-.5-.59-.92-1.1-1.15-1.08-.46-2.32-.41-3.35.15.73-1.53,2.46-2.35,4.15-1.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M445.84,45.36c-.71.53-1.81.17-1.86.22-.83.68-1.69,1.32-2.58,1.92-.44.34-1.13.78-1,1.43.23,1.15,2.13.8,2.85.44s1.31-.94,1.99-1.35c.48-.29.96-.44,1.04-1.06-.02-.56-.16-1.1-.42-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M446.25,46.75c-.09.57-.55.72-1.05,1.02-.69.42-1.3,1.02-2.01,1.37s-2.32.65-2.79-.17c.25,1.11,2.12.76,2.84.41s1.31-.94,1.99-1.35c.48-.29.96-.44,1.04-1.06,0-.07,0-.14-.01-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M442.4,43.49c-.65.53-1.65.22-1.67.27-.75.63-1.54,1.21-2.37,1.75-.4.31-1.03.72-.92,1.31.2,1.06,1.95.73,2.61.4s1.2-.86,1.82-1.24c.44-.27.88-.4.95-.95-.02-.54-.17-1.07-.42-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M442.81,44.82c-.08.53-.52.67-.95.93-.64.38-1.19.93-1.85,1.26s-2.12.6-2.55-.16c.23,1.02,1.94.7,2.6.38s1.2-.86,1.82-1.24c.44-.27.88-.4.95-.95,0-.07,0-.15-.01-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M452.17,23.38c-1.92.24-3.86-.03-5.63-.79.03.57.07,1.06.07,1.06-2.29,1.6-6.89,4.22-7.18,6.04.3,5.76,1.2,13.99,1.46,14.11.72.33,1.22.28,1.56-.06,0,0,1.44-4.88,1.02-12.04,0,0,8.01-3.44,8.53-5.32.23-.76.31-1.56.22-2.34,0-.2-.02-.43-.04-.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M454.84,22.63c-1.52.66-3.21.88-4.86.63,0,.77.11,2.22.11,2.22-2.29,1.57-6.88,4.22-7.18,6.04.3,5.77.86,14.11,1.1,14.21.63.26,1.35.17,1.9-.22,0,0,1.44-4.82,1.03-11.98,0-.14,6.87-3.42,7.73-4.26s1.04-2.16,1.02-3.38c-.05-1.13-.34-2.24-.85-3.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M456.52,23.86s2.54,4.36-1.7,6.6c-4.47,2.37-7.18,2.92-7.18,2.92l-.67.15c.21,1.5.21,3.03,0,4.53,0,0-3.19,1.06-7.25-2.39l-1.34-4.21-.17-1.13c-.16-.77.09-1.58.68-2.13.98-.86,4.07-3.05,5.99-4.31s3.46-2.46,3.46-2.46l.33-.3s2.28,1.76,6.44,1.17c.55.44,1.03.96,1.42,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_7",
    "data-name": " \\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 7",
    className: "cls-31",
    d: "M454,30.34c.39-.34.8-.65,1.23-.94.46-.22.87-.51,1.23-.86.39-.38.97-1.96,1.27-3.5.27-1.73.24-3.49-.09-5.21-.53-2.05-1.24-4.06-2.12-5.99-.55-1.16-.25-1.86.27-2.38.6-.6,1.23-.59,1.95,1.03,1.01,2.26,1.76,4.63,2.23,7.05.29,1.77.26,3.57-.08,5.32-.3,1.54-.79,3.03-1.45,4.46-.19.42-.22.77-.48,1.6-.25.84-.7,1.6-1.31,2.24-.55.5-.83.59-.98.53s-.18-.27.05-.53c.38-.38.7-.82.92-1.3,0,0-.46.58-.77.91-.27.29-.59.54-.93.75-.33.2-.86-.03-.64-.29s.46-.41.91-.89c.24-.26.45-.54.62-.85-.32.31-.66.59-1.03.85-.28.22-.63.36-.99.39-.19,0-.44-.21-.13-.5.45-.31.86-.66,1.22-1.06.34-.42.52-.76.41-.76s-.29.27-.72.46-.94.13-1.03-.11.05-.15.44-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M458.85,14.66s-1.54,1.33-3.25,1.06l-.68-2.79s-.45-1.46.84-2.02,2.54.9,3.09,3.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M450.4,9.8s-1.65-.49-3.44,3.09l.66.39c.83-1.23,1.76-2.39,2.78-3.48Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_\\u0413\\u0440\\u0443\\u043F\\u043F\\u0430_",
    "data-name": " \\u0413\\u0440\\u0443\\u043F\\u043F\\u0430 "
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u0413\\u0440\\u0443\\u043F\\u043F\\u0430_2",
    "data-name": " \\u0413\\u0440\\u0443\\u043F\\u043F\\u0430 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_8",
    "data-name": " \\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 8",
    className: "cls-15",
    d: "M438.89,25.25l5.94-3.32c.11-.06.23-.06.34,0l10.43,5.83-6.11,3.42-10.6-5.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M449.63,29.87l.46.25s.03.06,0,.09l-.43.24s-.1.02-.14,0l-.46-.26s-.03-.05,0-.08l.43-.24s.1-.02.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M448.98,29.51l.46.26s.03.05,0,.08l-.43.24s-.1.02-.14,0l-.46-.26s-.03-.06,0-.08l.43-.24s.1-.02.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M448.33,29.14l.45.25s.03.06,0,.09l-.43.24s-.1.02-.14,0l-.46-.26s-.03-.05,0-.08l.43-.24s.1-.02.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M447.7,28.79l.46.26s.03.05,0,.08l-.43.24s-.1.02-.15,0l-.45-.25s-.03-.06,0-.09l.43-.24s.1-.02.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M447.06,28.43l.45.26s.03.06,0,.08l-.43.24s-.1.02-.15,0l-.46-.27s-.03-.06,0-.08l.43-.24c.05-.02.11-.02.16.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M446.42,28.07l.45.25s.03.06,0,.08l-.43.24s-.1.02-.14,0l-.46-.26s-.03-.05,0-.08l.43-.24s.1-.02.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M445.77,27.71l.46.26s.03.05,0,.08l-.43.24s-.1.02-.14,0l-.46-.26s-.03-.06,0-.08l.43-.24s.1-.02.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M445.13,27.35l.46.26s.03.06,0,.08l-.43.24s-.1.02-.14,0l-.46-.26s-.03-.06,0-.08l.43-.24s.1-.02.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M444.49,26.99l.46.25s.03.06,0,.09l-.43.24s-.1.02-.14,0l-.46-.25s-.03-.06,0-.09l.43-.24s.1-.02.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M443.84,26.61l.46.26s.03.06,0,.08l-.43.24s-.1.02-.14,0l-.46-.26s-.03-.06,0-.08l.43-.24s.1-.02.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M443.2,26.26l.46.26s.03.06,0,.08l-.43.24s-.1.02-.14,0l-.46-.26s-.03-.05,0-.08l.43-.24s.1-.02.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M442.56,25.91l.46.26s.03.05,0,.08l-.43.24s-.1.02-.15,0l-.45-.25s-.03-.06,0-.09l.43-.24s.1-.02.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M441.92,25.55l.45.26s.03.06,0,.08l-.43.24s-.1.02-.15,0l-.45-.26s-.03-.06,0-.08l.41-.24c.05-.03.12-.03.17,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M440.96,25.01l.76.43s.03.06,0,.09l-.43.24s-.1.02-.14,0l-.76-.43s-.03-.06,0-.08l.43-.24s.1-.02.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M449.3,28.99l.46.26s.03.05,0,.08l-.43.24s-.1.02-.15,0l-.45-.25s-.03-.06,0-.09l.43-.24s.1-.02.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M448.66,28.62l.45.26s.03.05,0,.08l-.43.24s-.1.02-.14,0l-.46-.26s-.03-.06,0-.08l.43-.24s.1-.02.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M448.01,28.26l.46.26s.03.06,0,.08l-.43.24s-.1.02-.14,0l-.46-.26s-.03-.06,0-.08l.43-.24s.1-.02.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M447.37,27.9l.46.25s.03.06,0,.09l-.43.24s-.1.02-.14,0l-.46-.26s-.03-.05,0-.08l.43-.24s.1-.02.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M446.73,27.54l.45.26s.03.06,0,.08l-.43.24s-.1.02-.14,0l-.46-.26s-.03-.05,0-.08l.43-.24s.1-.02.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M446.08,27.19l.46.25s.03.06,0,.09l-.43.24s-.1.02-.14,0l-.46-.25s-.03-.06,0-.09l.43-.24s.1-.02.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M445.44,26.82l.46.26s.03.05,0,.08l-.43.24s-.1.02-.14,0l-.46-.26s-.03-.06,0-.08l.43-.24s.1-.02.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M444.8,26.46l.45.26s.03.06,0,.08l-.43.24s-.1.02-.15,0l-.46-.26s-.03-.06,0-.08l.43-.24s.1-.02.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M444.15,26.08l.46.26s.03.06,0,.08l-.43.24s-.1.02-.14,0l-.46-.26s-.03-.05,0-.08l.43-.24s.1-.02.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M443.51,25.74l.46.25s.03.06,0,.09l-.43.24s-.1.02-.14,0l-.46-.25s-.03-.06,0-.09l.43-.24s.1-.02.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M442.84,25.38l.45.26s.03.05,0,.08l-.43.24s-.1.02-.15,0l-.46-.26s0-.06,0-.08l.43-.24s.1-.02.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M442.22,25.01l.46.26s.03.06,0,.08l-.43.24s-.1.02-.14,0l-.46-.26s-.03-.06,0-.08l.43-.24s.1-.02.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M449.94,29.34l.76.43s.03.06,0,.08l-.43.24s-.1.02-.15,0l-.76-.43s-.03-.05,0-.08l.43-.24s.1-.02.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M440.99,25.01l.46.25s.09.02.13,0l.46-.26s.03-.04.02-.06c0,0,0-.01-.02-.02h-.04s-.03-.05,0-.07l.48-.27s.04-.05,0-.07l-.29-.16s-.09-.02-.14,0l-.45.25-.09.05-.07.04-.07.04-.39.22s-.02.04,0,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M452.12,28.47l.45.26s.03.06,0,.08l-.43.24s-.1.02-.15,0l-.45-.26s-.03-.06,0-.08l.43-.24s.1-.02.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M451.48,28.11l.46.26s.03.05,0,.08l-.43.24s-.1.02-.14,0l-.46-.25s-.03-.06,0-.09l.43-.24s.1-.02.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M450.83,27.75l.46.26s.03.06,0,.08l-.43.24s-.1.02-.14,0l-.46-.26s-.03-.06,0-.08l.43-.24s.1-.02.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M445.38,24.69l.45.26s.03.06,0,.08l-.43.24s-.1.02-.15,0l-.46-.26s-.03-.06,0-.08l.43-.24s.1-.02.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M444.74,24.34l.46.25s.03.06,0,.09l-.43.24s-.1.02-.15,0l-.45-.25s-.03-.06,0-.09l.43-.24s.1-.02.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M444.09,23.98l.46.26s.03.06,0,.08l-.43.24s-.1.02-.14,0l-.46-.26s-.03-.06,0-.08l.43-.24s.1-.02.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M443.45,23.62l.46.26s.03.05,0,.08l-.43.24s-.1.02-.14,0l-.49-.24s-.03-.06,0-.08l.43-.24c.05-.04.12-.04.18,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M450.03,27.3l.62.35s.03.05,0,.08l-.43.24s-.1.02-.14,0l-.64-.34s-.03-.05,0-.08l.43-.24s.11-.04.16,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M446.02,25.06l.62.35s.03.05,0,.08l-.43.24s-.1.02-.14,0l-.62-.35s-.03-.05,0-.08l.43-.24s.1-.02.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M446.82,25.5l3.02,1.69s.03.06,0,.08l-.43.24s-.1.02-.14,0l-3.02-1.69s-.03-.05,0-.08l.43-.24s.1-.02.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M449.75,28.54l.45.26s.03.05,0,.08l-.43.24s-.1.02-.14,0l-.46-.25s-.03-.06,0-.09l.43-.24s.1-.02.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M449.11,28.18l.45.26s.03.06,0,.08l-.43.24s-.1.02-.14,0l-.46-.26s-.03-.06,0-.08l.43-.24s.1-.02.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M448.46,27.82l.45.26s.03.05,0,.08l-.43.24s-.1.02-.14,0l-.46-.25s-.03-.06,0-.09l.43-.24s.1-.02.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M447.82,27.46l.45.26s.03.06,0,.08l-.43.24s-.1.02-.15,0l-.46-.26s-.03-.06,0-.08l.43-.24s.1-.02.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M447.18,27.1l.45.25s.03.06,0,.09l-.43.24s-.1.02-.15,0l-.46-.25s-.03-.06,0-.09l.43-.24s.1-.02.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M446.54,26.74l.45.26s.03.06,0,.08l-.43.24s-.1.02-.15,0l-.46-.26s0-.06,0-.08l.43-.24s.1-.02.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M445.89,26.38l.45.25s.03.06,0,.09l-.43.24s-.1.02-.15,0l-.46-.26s-.03-.05,0-.08l.43-.24s.1-.02.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M445.25,26.02l.45.26s.03.05,0,.08l-.43.24s-.1.02-.15,0l-.46-.26s-.03-.06,0-.08l.43-.24s.11-.02.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M444.61,25.66l.45.26s.03.06,0,.08l-.43.24s-.1.02-.15,0l-.45-.26s-.03-.05,0-.08l.43-.24s.1-.02.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M443.97,25.3l.45.26s.03.05,0,.08l-.43.24s-.1.02-.15,0l-.45-.26s-.03-.06,0-.08l.43-.24s.1-.02.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M443.33,24.94l.45.26s.03.06,0,.08l-.43.24s-.1.02-.15,0l-.45-.26s-.03-.05,0-.08l.43-.24s.1-.02.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M442.68,24.58l.45.26s.03.05,0,.08l-.43.24s-.1.02-.15,0l-.45-.25s-.03-.06,0-.08l.43-.24s.1-.02.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M450.39,28.89l.94.53s.03.06,0,.08l-.43.24s-.1.02-.15,0l-.94-.53s-.03-.05,0-.08l.43-.24s.1-.02.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M450.69,28.37l.46.26s.03.05,0,.08l-.43.24s-.1.02-.14,0l-.46-.25s-.03-.06,0-.09l.43-.24s.1-.02.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M450.04,28.01l.46.26s.03.06,0,.08l-.43.24s-.1.02-.14,0l-.46-.26s-.03-.06,0-.08l.43-.24s.1-.02.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M449.43,27.68l.46.26s.03.05,0,.08l-.46.2s-.1.02-.14,0l-.46-.25s-.03-.06,0-.09l.43-.24c.06-.02.12,0,.16.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M448.76,27.29l.46.26s.03.06,0,.08l-.43.24s-.1.02-.14,0l-.46-.26s-.03-.06,0-.08l.43-.24s.1-.02.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M448.12,26.93l.46.25s.03.06,0,.09l-.43.24s-.1.02-.14,0l-.46-.25s-.03-.06,0-.09l.43-.24s.1-.02.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M447.48,26.57l.46.26s.03.06,0,.08l-.43.24s-.1.02-.14,0l-.46-.26s-.03-.06,0-.08l.43-.24s.1-.02.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M446.83,26.21l.46.25s.03.06,0,.09l-.43.24s-.1.02-.14,0l-.46-.26s-.03-.05,0-.08l.43-.24s.1-.02.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M446.19,25.85l.46.26s.03.06,0,.08l-.43.24s-.1.02-.14,0l-.46-.26s-.03-.06,0-.08l.43-.24s.1-.02.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M445.55,25.49l.46.25s.03.06,0,.09l-.42.25s-.1.02-.14,0l-.46-.26s-.03-.05,0-.08l.43-.24s.08-.03.13-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M444.91,25.13l.46.26s.03.05,0,.08l-.43.24s-.1.02-.14,0l-.46-.26s-.03-.06,0-.08l.43-.24s.1-.02.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M444.26,24.77l.46.26s.03.06,0,.08l-.43.24s-.1.02-.14,0l-.46-.26s-.03-.05,0-.08l.43-.24s.1-.02.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M442.84,23.95l1.25.7s.03.05,0,.08l-.43.24s-.1.02-.14,0l-1.25-.7s-.03-.05,0-.08l.43-.24s.1-.02.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M451.33,28.74l.62.35s.03.06,0,.09l-.43.24s-.1.02-.14,0l-.62-.35s-.03-.05,0-.08l.43-.24s.1-.02.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M440.32,25.38l9.11,5.11s.03.06,0,.08l-.21.12s-.1.02-.15,0l-9.12-5.11s-.03-.06,0-.08l.21-.12s.11-.03.15,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_9",
    "data-name": " \\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 9",
    className: "cls-45",
    points: "451.1 25.71 451.04 25.74 449.47 26.62 446.69 25.06 446.62 25.02 448.25 24.11 451.1 25.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_10",
    "data-name": " \\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 10",
    className: "cls-21",
    points: "451.04 25.74 449.47 26.62 446.69 25.06 448.25 24.18 451.04 25.74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11",
    "data-name": " \\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11",
    className: "cls-21",
    d: "M455.58,27.76v.14c0,.2-.11.38-.29.48l-5.54,3.1c-.17.1-.38.1-.55,0l-10.03-5.61c-.18-.09-.29-.28-.29-.48v-.14l10.59,5.93,6.11-3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_12",
    "data-name": " \\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 12",
    className: "cls-21",
    d: "M449.47,31.18v.37c-.1,0-.2-.03-.29-.07l-10.01-5.61c-.18-.09-.29-.28-.29-.48v-.14l10.59,5.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_13",
    "data-name": " \\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 13",
    className: "cls-15",
    d: "M449.31,31.26c-.19.07-.41.06-.59-.04l-9.97-5.58c-.18-.1-.3-.26-.33-.46l-1.1-6.31s0-.07,0-.11c0-.18.07-.35.2-.47l10.36,5.8c.13.07.22.2.25.34l1.17,6.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_14",
    "data-name": " \\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 14",
    className: "cls-21",
    d: "M449.47,31.18l-.07.04-.09.04-1.18-6.83c-.03-.14-.12-.27-.25-.34l-10.36-5.8s.09-.08.14-.1l10.38,5.81c.13.07.22.2.25.34l1.18,6.84Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "323.86 193.95 312.75 187.72 323.86 181.5 334.98 187.72 323.86 193.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "341.49 183.97 330.37 177.75 341.49 171.52 352.61 177.75 341.49 183.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "348.09 140.19 336.97 133.96 348.09 127.73 359.21 133.96 348.09 140.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "348.09 180.37 336.97 174.14 336.97 133.96 348.09 140.19 348.09 180.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "348.09 180.37 336.97 174.14 336.97 133.96 348.09 140.19 348.09 180.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "359.21 174.14 348.09 180.37 348.09 140.19 359.21 133.96 359.21 174.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "359.21 174.14 348.09 180.37 348.09 140.19 359.21 133.96 359.21 174.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "331.41 160.64 320.29 154.41 331.41 148.19 342.53 154.41 331.41 160.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "331.41 189.66 320.29 183.43 320.29 154.41 331.41 160.64 331.41 189.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "331.41 189.66 320.29 183.43 320.29 154.41 331.41 160.64 331.41 189.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "342.53 183.43 331.41 189.66 331.41 160.64 342.53 154.41 342.53 183.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "342.53 183.43 331.41 189.66 331.41 160.64 342.53 154.41 342.53 183.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "309.62 202.11 298.5 195.89 309.62 189.66 320.74 195.89 309.62 202.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "313.65 181.91 302.53 175.68 313.65 169.46 324.77 175.68 313.65 181.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "313.65 199.76 302.53 193.54 302.53 175.68 313.65 181.91 313.65 199.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "313.65 199.76 302.53 193.54 302.53 175.68 313.65 181.91 313.65 199.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "324.77 193.54 313.65 199.76 313.65 181.91 324.77 175.68 324.77 193.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "324.77 193.54 313.65 199.76 313.65 181.91 324.77 175.68 324.77 193.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M428.19,241.55l-7.13-9.97-3.46-1.5c-2.62-.59-5.31-.89-8-.89-3.22,3.15-23.54,3.99-31.61.11-9.15-4.41-13.95-9.79-15.44-13.09-2.66-5.86,2.41-12.74,2.41-12.74-13.84,7.75-13.84,20.37,0,28.12,12.97,7.27,33.58,7.72,47.51,1.36h0l15.72,8.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "467.29 266.18 419.38 239.35 427.52 234.79 475.43 261.62 467.29 266.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M366.67,229.14c-13.84-7.75-13.84-20.36,0-28.11,13.84-7.75,36.36-7.75,50.21,0,13.84,7.75,13.84,20.36,0,28.11-13.84,7.75-36.36,7.76-50.21,0ZM410.75,204.45c-10.47-5.86-27.5-5.86-37.96,0s-10.47,15.41,0,21.27,27.49,5.86,37.96,0,10.47-15.41,0-21.27h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "356.31 215.67 356.31 209.72 362.53 212.69 356.31 215.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M373.93,225.5c.25.3,1.14,6.14,18.87,6.14s16.97-6.89,16.97-6.89c0,0-16.72,2.23-16.97,2.23s-18.87-1.47-18.87-1.47Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "427.26 209.72 427.26 215.08 422.15 211.92 427.26 209.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M375.64,196.75c5.15-1.94,10.61-2.96,16.14-3.01,5.37.02,10.68,1.12,15.59,3.23l-1.13,1.82h-29.64l-.97-2.04Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 391.78,
    cy: 211.78,
    rx: 26.43,
    ry: 14.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M366.67,223.78c-13.84-7.75-13.84-20.37,0-28.12,13.84-7.75,36.36-7.75,50.21,0,13.84,7.75,13.84,20.37,0,28.12-13.84,7.75-36.36,7.75-50.21,0ZM410.75,199.1c-10.47-5.86-27.5-5.86-37.96,0s-10.47,15.4,0,21.26c10.47,5.86,27.49,5.86,37.96,0,10.47-5.86,10.47-15.41,0-21.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "425.17 232.27 413.16 225.5 420.13 221.59 432.14 228.37 425.17 232.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "425.17 237.67 413.17 230.94 413.17 225.5 425.17 232.24 425.17 237.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "468.81 265.24 420.91 238.41 420.91 229.3 468.81 256.13 468.81 265.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "468.82 256.13 420.91 229.3 429.05 224.75 476.96 251.57 468.82 256.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M468.81,265.24c.49-.05,8.14-4.45,8.14-4.45v-9.23l-8.14,4.56v9.11Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Men_11",
    "data-name": "Men 11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_15",
    "data-name": " \\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 15",
    className: "cls-31",
    d: "M332.41,145.06c.81,1.4,1.79,2.69,2.92,3.86.32.36,2.74-.53,2.24-.8s-2.1-2.41-2.9-3.84c-.67-1.72-1.24-3.47-1.7-5.24-.5-1.76-.93-4.33-1.3-5.55-.2-.91-.92-1.63-1.86-1.84-.88-.2-1.44.04-1.28,1.06.28,1.8,1.73,8.8,3.88,12.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M331.02,172.48c.75.6,1.87.05,1.92.11.88.8,1.81,1.55,2.78,2.25.47.36,1.21.84,1.1,1.53-.24,1.23-2.27.85-3.03.47s-1.39-1-2.12-1.44c-.52-.31-1.03-.47-1.1-1.11-.09-.38.32-1.81.46-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M330.53,174.04c.1.61.6.77,1.1,1.06.74.44,1.39,1.06,2.16,1.46s2.48.7,2.97-.19c-.27,1.19-2.27.81-3.02.44s-1.39-1-2.12-1.44c-.52-.31-1.03-.47-1.1-1.11,0-.08,0-.16.02-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M338.66,168.22c.76.6,2.07-.05,2.13,0,.79.77,1.62,1.5,2.49,2.18.47.36,1.2.84,1.1,1.52-.24,1.24-2.27.86-3.04.48s-1.39-1-2.12-1.44c-.52-.31-1.03-.47-1.1-1.11.03-.58.22-1.14.54-1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M338.1,169.68c.1.61.6.77,1.1,1.06.74.44,1.39,1.06,2.15,1.46s2.48.7,2.97-.19c-.26,1.21-2.24.84-3.01.46s-1.39-1-2.12-1.44c-.55-.31-1.03-.47-1.1-1.11-.01-.08-.01-.17,0-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_16",
    "data-name": " \\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 16",
    className: "cls-41",
    d: "M320.94,149.06c-.83,5.06,1.48,6.95,4.49,8.03,2.16.77,5.26,1.96,5.26,1.96,0,0-.04,1.11-.07,3.6,0,2.2.27,10.21.27,10.21.72.36,1.58.36,2.31,0,0,0,1.22-6.14,1.48-8.91.35-3.75.94-6.21.75-7.02-.18-.71-4.39-2.73-5.75-3.81l8.89,2.86c-.18.93-.26,1.88-.26,2.83.08,2.98.25,9.43.25,9.43,0,0,1.22.85,2.26,0,0,0,2.23-12.78,1.96-14.46-.26-1.6-8.07-4.88-9.45-6.01-.48-.39-1.12-.55-1.73-.46l-10.65,1.75Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_\\u0413\\u0440\\u0443\\u043F\\u043F\\u0430_3",
    "data-name": " \\u0413\\u0440\\u0443\\u043F\\u043F\\u0430 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u0413\\u0440\\u0443\\u043F\\u043F\\u0430_4",
    "data-name": " \\u0413\\u0440\\u0443\\u043F\\u043F\\u0430 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_17",
    "data-name": " \\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 17",
    className: "cls-15",
    d: "M342.19,151.19l-5.95-3.34c-.11-.06-.24-.06-.35,0l-10.43,5.86,6.13,3.43,10.6-5.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M331.3,155.89l-.45.26s-.03.05,0,.08l.43.24s.1.02.15,0l.45-.25s.03-.06,0-.09l-.43-.24s-.1-.02-.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M331.94,155.53l-.45.26s-.03.06,0,.08l.43.24s.1.02.14,0l.46-.26s0-.06,0-.08l-.43-.24s-.1-.02-.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M332.59,155.16l-.46.26s-.03.05,0,.08l.43.24s.1.02.14,0l.46-.25s.03-.06,0-.09l-.43-.24s-.1-.02-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M333.23,154.81l-.46.26s-.03.05,0,.08l.43.24s.1.02.14,0l.46-.26s.03-.06,0-.08l-.43-.24s-.1-.02-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M333.87,154.45l-.46.26s-.03.06,0,.08l.43.24s.1.02.14,0l.46-.26s.03-.06,0-.08l-.43-.24s-.1-.02-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M334.51,154.09l-.46.25s-.03.06,0,.09l.43.24s.1.02.14,0l.46-.25s.03-.06,0-.09l-.43-.24s-.1-.02-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M335.15,153.73l-.46.26s-.03.06,0,.08l.43.24s.1.02.14,0l.46-.26s.03-.06,0-.08l-.43-.24s-.1-.02-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M335.82,153.36l-.46.26s-.03.06,0,.08l.43.24s.1.02.15,0l.45-.26s.03-.05,0-.08l-.43-.24s-.1-.02-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M336.44,153.01l-.45.26s-.03.05,0,.08l.43.24s.1.02.15,0l.45-.25s.03-.06,0-.08l-.43-.24s-.1-.02-.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M337.08,152.65l-.45.26s-.03.06,0,.08l.43.24s.1.02.15,0l.46-.26s0-.06,0-.08l-.43-.24s-.1-.02-.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M337.72,152.29l-.45.25s-.03.06,0,.09l.43.24s.1.02.14,0l.46-.26s.03-.05,0-.08l-.43-.24s-.1-.02-.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M338.37,151.93l-.46.26s-.03.05,0,.08l.43.24s.1.02.14,0l.46-.26s.03-.06,0-.08l-.43-.24s-.1-.02-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M339.01,151.57l-.46.26s-.03.06,0,.08l.43.24s.1.02.14,0l.46-.26s.03-.05,0-.08l-.43-.24s-.1-.02-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M339.96,151.03l-.76.43s-.03.05,0,.08l.43.24s.1.02.14,0l.76-.43s.03-.06,0-.08l-.43-.24s-.1-.02-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M331.63,155l-.46.26s-.03.05,0,.08l.43.24s.1.02.14,0l.46-.26s.03-.06,0-.08l-.43-.24s-.1-.02-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M332.27,154.64l-.46.26s-.03.06,0,.08l.43.24s.1.02.14,0l.46-.26s.03-.06,0-.08l-.43-.24s-.1-.02-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M332.91,154.28l-.46.26s0,.06,0,.08l.43.24s.1.02.15,0l.45-.26s.03-.05,0-.08l-.43-.24s-.1-.02-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M333.56,153.92l-.45.26s-.03.05,0,.08l.43.24s.1.02.14,0l.46-.25s.03-.06,0-.09l-.43-.24s-.1-.02-.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M334.18,153.57l-.46.25s-.03.06,0,.09l.43.24s.1.02.14,0l.46-.26s.03-.05,0-.08l-.43-.24s-.1-.02-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M334.84,153.2l-.46.26s0,.05,0,.08l.43.24s.1.02.15,0l.45-.25s.03-.06,0-.09l-.43-.24s-.1-.02-.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M335.48,152.84l-.45.26s-.03.06,0,.08l.43.24s.1.02.14,0l.46-.26s.03-.06,0-.08l-.43-.24s-.1-.02-.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M336.13,152.48l-.46.26s-.03.06,0,.08l.43.24s.1.02.14,0l.46-.26s.03-.05,0-.08l-.43-.24s-.1-.02-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M336.77,152.12l-.46.25s-.03.06,0,.09l.43.24s.1.02.15,0l.45-.26s.03-.05,0-.08l-.43-.24s-.1-.02-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M337.41,151.76l-.45.26s-.03.05,0,.08l.43.24s.1.02.14,0l.46-.26s.03-.06,0-.08l-.43-.24s-.1-.02-.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M338.06,151.4l-.46.26s-.03.06,0,.08l.43.24s.1.02.14,0l.46-.26s.03-.06,0-.08l-.43-.24s-.1-.02-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M338.7,151.04l-.46.26s-.03.06,0,.08l.43.24s.1.02.15,0l.45-.26s.03-.05,0-.08l-.43-.24s-.1-.02-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M330.98,155.37l-.76.43s-.03.06,0,.08l.43.24s.1.02.14,0l.76-.43s.03-.06,0-.09l-.43-.24s-.1-.02-.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M339.93,151.01l-.46.26s-.09.02-.14,0l-.46-.26s-.04-.05,0-.07h.03s.04-.05,0-.07l-.48-.27s-.04-.05,0-.07l.29-.16s.09-.02.13,0l.46.26.09.05.07.04.07.04.4.22s.01.04,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M328.81,154.49l-.46.26s-.03.06,0,.08l.43.24s.1.02.14,0l.46-.26s.03-.05,0-.08l-.43-.24s-.1-.02-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M329.45,154.13l-.45.26s-.03.05,0,.08l.43.24s.1.02.14,0l.46-.26s.03-.06,0-.08l-.43-.24s-.1-.02-.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M330.09,153.77l-.45.25s-.03.06,0,.08l.43.24s.1.02.15,0l.45-.26s.03-.05,0-.08l-.43-.24s-.1-.02-.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M335.55,150.71l-.46.26s-.03.06,0,.08l.43.24s.1.02.14,0l.46-.26s.03-.06,0-.08l-.43-.24s-.1-.02-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M336.19,150.36l-.46.26s-.03.05,0,.08l.43.24s.1.02.14,0l.46-.26s.03-.06,0-.08l-.43-.24s-.1-.02-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M336.83,149.99l-.45.26s-.03.06,0,.08l.43.24s.1.02.14,0l.46-.26s0-.05,0-.08l-.43-.24s-.1-.02-.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M337.47,149.64l-.46.26s0,.05,0,.08l.43.24s.1.02.15,0l.45-.26s.03-.06,0-.08l-.43-.24s-.1-.02-.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M330.88,153.32l-.62.35s-.03.06,0,.08l.43.24s.1.02.14,0l.62-.35s.03-.06,0-.09l-.43-.24s-.1-.02-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M334.91,151.08l-.62.35s-.03.06,0,.08l.43.24s.1.02.14,0l.62-.35s.03-.06,0-.09l-.43-.24s-.1-.02-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M334.1,151.53l-3.02,1.69s-.03.06,0,.08l.43.24s.1.02.14,0l3.02-1.69s.03-.05,0-.08l-.43-.24s-.1-.02-.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M331.18,154.56l-.46.26s-.03.05,0,.08l.43.24s.1.02.14,0l.46-.26s.03-.06,0-.08l-.43-.24s-.1-.02-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M331.82,154.2l-.46.26s-.03.06,0,.08l.43.24s.1.02.14,0l.46-.26s.03-.05,0-.08l-.43-.24s-.1-.02-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M332.46,153.85l-.46.26s-.03.05,0,.08l.43.24s.1.02.14,0l.46-.26s.03-.06,0-.08l-.43-.24s-.1-.02-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M333.11,153.48l-.46.26s-.03.06,0,.08l.43.24s.1.02.14,0l.46-.26s.03-.05,0-.08l-.43-.24s-.1-.02-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M333.75,153.12l-.46.26s-.03.05,0,.08l.43.24s.1.02.14,0l.46-.25s.03-.06,0-.08l-.43-.24s-.1-.02-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M334.39,152.78l-.46.26s-.03.06,0,.08l.43.24s.1.02.14,0l.46-.26s.03-.06,0-.08l-.43-.24s-.1-.02-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M335.03,152.4l-.46.26s-.03.05,0,.08l.43.24s.1.02.14,0l.46-.25s.03-.06,0-.09l-.43-.24s-.1-.02-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M335.67,152.04l-.46.26s-.03.06,0,.08l.43.24s.1.02.14,0l.46-.26s.03-.06,0-.08l-.43-.24s-.1-.02-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M336.32,151.68l-.46.25s-.03.06,0,.09l.43.24s.1.02.14,0l.46-.25s.03-.06,0-.09l-.43-.24s-.1-.02-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M336.96,151.32l-.46.26s-.03.06,0,.08l.43.24s.1.02.14,0l.46-.26s.03-.06,0-.08l-.43-.24s-.1-.02-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M337.6,150.96l-.46.25s-.03.06,0,.09l.43.24s.1.02.14,0l.46-.26s.03-.05,0-.08l-.43-.24s-.1-.02-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M338.24,150.6l-.46.26s-.03.06,0,.08l.43.24s.1.02.14,0l.46-.26s.03-.06,0-.08l-.43-.24s-.1-.02-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M330.54,154.91l-.94.53s-.03.06,0,.09l.43.24s.1.02.14,0l.94-.53s.03-.05,0-.08l-.43-.24s-.1-.03-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M330.24,154.38l-.45.26s-.03.05,0,.08l.43.24s.1.02.15,0l.45-.26s.03-.06,0-.08l-.43-.24s-.1-.02-.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M330.88,154.02l-.45.26s-.03.06,0,.08l.43.24s.1.02.15,0l.45-.26s.03-.05,0-.08l-.43-.24s-.1-.02-.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M331.52,153.67l-.46.26s0,.05,0,.08l.43.24s.1.02.15,0l.45-.26s.03-.06,0-.08l-.43-.24s-.1-.02-.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M332.16,153.32l-.46.26s0,.06,0,.08l.43.24s.1.02.15,0l.45-.26s.03-.05,0-.08l-.43-.24s-.1-.02-.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M332.8,152.95l-.46.26s-.03.05,0,.08l.43.24s.1.02.15,0l.45-.26s.03-.06,0-.08l-.43-.24s-.1-.02-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M333.45,152.59l-.46.26s-.03.06,0,.08l.43.24s.1.02.15,0l.45-.26s.03-.05,0-.08l-.43-.24s-.1-.02-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M334.09,152.25l-.46.26s-.03.05,0,.08l.43.24s.1.02.15,0l.45-.25s.03-.06,0-.09l-.43-.24s-.1-.02-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M334.73,151.87l-.46.26s-.03.06,0,.08l.43.24s.1.02.14,0l.46-.26s.03-.06,0-.08l-.43-.24s-.1-.02-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M335.37,151.51l-.46.26s-.03.05,0,.08l.43.24s.1.02.14,0l.46-.25s.03-.06,0-.09l-.43-.24s-.1-.02-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M336.02,151.15l-.46.26s-.03.06,0,.08l.43.24s.1.02.14,0l.46-.26s.03-.06,0-.08l-.43-.24s-.1-.02-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M336.66,150.79l-.46.25s-.03.06,0,.09l.43.24s.1.02.14,0l.46-.25s.03-.06,0-.09l-.43-.24s-.1-.02-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M338.1,149.99l-1.25.7s-.03.06,0,.08l.43.24s.1.02.14,0l1.25-.7s.03-.05,0-.08l-.43-.24s-.1-.02-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M329.59,154.75l-.62.35s-.03.05,0,.08l.43.24s.1.02.15,0l.61-.35s.03-.05,0-.08l-.43-.24s-.1-.02-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M340.61,151.39l-9.12,5.12s-.03.06,0,.08l.22.12s.1.02.14,0l9.12-5.11s.03-.06,0-.08l-.22-.12s-.1-.03-.14-.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_18",
    "data-name": " \\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 18",
    className: "cls-45",
    points: "329.94 151.62 330 151.66 331.58 152.54 334.37 150.97 334.43 150.94 332.8 150.02 329.94 151.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_19",
    "data-name": " \\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 19",
    className: "cls-21",
    points: "330 151.66 331.58 152.54 334.37 150.97 332.8 150.09 330 151.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_20",
    "data-name": " \\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 20",
    className: "cls-21",
    d: "M325.44,153.68v.13c0,.2.11.39.29.48l5.55,3.11c.09.05.19.07.29.07.1,0,.2-.03.29-.07l10.05-5.63c.18-.1.29-.29.29-.48v-.11l-10.62,5.93-6.13-3.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_21",
    "data-name": " \\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 21",
    className: "cls-15",
    d: "M331.73,157.2c.19.07.41.06.59-.04l10.01-5.61c.18-.1.3-.27.33-.46l1.1-6.33s0-.07,0-.11c0-.18-.07-.34-.2-.47l-10.39,5.82c-.12.08-.21.2-.24.34l-1.19,6.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_22",
    "data-name": " \\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 22",
    className: "cls-21",
    d: "M331.58,157.11l.07.04.09.04,1.19-6.86c.03-.14.12-.26.24-.34l10.4-5.82s-.09-.07-.14-.1l-10.43,5.86c-.13.07-.22.2-.24.34l-1.17,6.84Z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_23",
    "data-name": " \\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 23",
    className: "cls-31",
    d: "M324.02,130s.13,2.41.07,2.62-1.14.92-1.45,1.17,1.72,2.2,2.71,2.66,4.12-.72,4.18-2.21-.55-2.75-1.02-2.81-4.48-1.43-4.48-1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_24",
    "data-name": " \\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 24",
    className: "cls-15",
    d: "M323.75,133.04s1.81,2.61,4.32,2.85c.8-.76.87-3.46-.23-4.32,0,0,1.01-.79,1.7-.63.74.44,1.29,1.12,1.55,1.92.64,1.79.94,3.68.89,5.58-.04,2.56,0,9.02,0,9.02-.3,1.55-1.26,2.91-2.66,3.72-1.81.99-3.95,1.27-5.97.8-1.27-.29-1.75-.98-2.2-1.88.12-1.79.85-5.48.55-7.74s-.8-3.93-.93-5.76.25-1.78,1.19-2.43c.56-.42,1.16-.8,1.78-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_25",
    "data-name": " \\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 25",
    className: "cls-31",
    d: "M326.64,153.82c-.45-.29-.92-.55-1.41-.78-.46-.14-.87-.38-1.21-.71-.44-.42-1.17-2.01-1.68-3.56-.52-1.75-.72-3.57-.61-5.38.22-2.17,1.03-5.21,1.23-6.46s-.21-1.75-.81-2.21c-.71-.53-1.68-.3-2.2,1.45-.66,2.42-1.05,4.91-1.14,7.42-.03,1.86.26,3.71.86,5.48.54,1.51,1.26,2.96,2.16,4.31.25.4.33.76.7,1.6.36.83.93,1.56,1.65,2.13.63.44.93.53,1.1.42s.15-.3-.12-.53c-.45-.34-.83-.75-1.13-1.22,0,0,.55.53.92.83.32.26.67.48,1.05.65.37.16.88-.14.62-.39s-.55-.36-1.05-.8c-.28-.23-.54-.5-.75-.79.37.27.76.51,1.16.72.32.19.69.29,1.06.28.2,0,.43-.27.07-.53-.5-.26-.97-.57-1.39-.93-.41-.39-.64-.72-.55-.72s.33.23.81.38.98,0,1.04-.23.07-.19-.37-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_26",
    "data-name": " \\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 26",
    className: "cls-31",
    d: "M329.65,126.41h0c-.3-1.87-1.69-3.29-3.68-3.19-2.12.13-3.72,1.9-3.59,3.96.08,1.13.68,2.17,1.64,2.82.07.28.17.56.31.81.7.8,2.83,1.29,3.44,1.21.74-.06,1.37-.56,1.59-1.26.66-1.46.43-3.42.29-4.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M324.02,130h0l.18-1.63s-1.37-3.46,1.88-2.79c2.14.44,2.68.63,3.33-.77s-1.65-2.66-4.39-2.31c-1.95.2-3.42,1.82-3.38,3.73.08,1.02.36,3.13,2.38,3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M318.46,139.37s1.77,1.71,3.87,1.22c.3-.2,1.02-4.2,1.02-4.2,0,0,0-2.22-1.75-2.16s-3.14,5.14-3.14,5.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M331.85,136.06c.5-.02.96-.23,1.31-.57-.07-.89-1.25-4.3-3.63-4.55.65.44,1.16,1.04,1.48,1.74.37,1.1.65,2.23.83,3.38Z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M358.31,575.87c-1.15-.95-3.7-3.97-1.73-7.48.72-1.29,2.25-1.92,3.64-2.49,1.43-.47,2.78-1.14,4-2.01,2.16-1.79,2.77-4.76,4.2-7.14,1.66-2.74,4.73-4.79,7.99-4.65,3.73.16,6.84,3.12,8.25,6.48s1.44,7.11,1.49,10.74c0,2.01-.08,4.28-1.6,5.64-1.4,1.25-3.52,1.26-5.42,1.21l-20.37-.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M397.27,521.53h-53.58l9.65,55.82c.41,2.37,2.19,4.31,4.57,4.97l.19.05c.16.04.32.09.48.12.36.07.73.11,1.09.13v.05h24.14c.44,0,.88-.05,1.31-.13,2.86-.44,5.07-2.66,5.42-5.45l4.66-38.5.21-1.53h0l1.82-15.24.04-.28ZM387.18,557.16h-5.5l.56-16.2h6.37l-1.43,16.2ZM389.14,540.96h5.27l-1.96,16.2h-4.73l1.42-16.2ZM373.43,575.12l-.33-14.07h7.92l-.5,14.04-7.09.03ZM364.87,561.05h7.69l.33,14.07h-6.89l-1.13-14.07ZM365.47,575.12h-6.48c-.61-3.8-1.44-8.73-2.28-14.07h7.6l1.16,14.07ZM364.56,557.16l-1.33-16.23h8.82l.38,16.2-7.87.03ZM373.01,557.16l-.41-16.23h9.08l-.55,16.2-8.12.03ZM372.53,537.08l-.36-15h10.18l-.51,15h-9.31ZM372,537.08h-9.07l-1.2-15h9.89l.37,15ZM362.42,537.08h-9.59l-.95-5.79c-1-6.07-1.38-8.35-1.58-9.21h10.91l1.22,15ZM362.74,540.96l1.3,16.2h-7.92c-.27-1.64-.53-3.3-.81-4.97-.62-3.83-1.24-7.65-1.82-11.23h9.26ZM355.58,557.16h-5.16l-2.8-16.2h5.34c.79,4.98,1.7,10.55,2.61,16.17l.02.03ZM356.21,561.05c.79,4.89,1.56,9.67,2.27,14.07h-4.96l-2.43-14.07h5.13ZM381.07,575.12l.48-14.07h5.29l-1.27,14.04-4.49.03ZM382.37,537.08l.51-15h7.39l-1.33,15h-6.58ZM349.81,522.07c.22,1.08,1.19,6.99,2.5,15h-5.37l-2.6-15h5.47ZM390.27,575.12h-4.14l1.24-14.07h4.6l-1.7,14.07ZM394.88,537.08h-5.4l1.33-15h5.88l-1.82,15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M186.21,403.29s-.12-.22-.33-.62l-.93-1.8-3.5-6.86c-3.01-5.92-7.31-14.39-12.53-24.66l.21.07-47.97,22.8h0l.09-.24,17.14,34.02-.23-.08,34.63-16.34,9.88-4.64,2.67-1.19.68-.31.24-.1-.22.11-.71.3-2.59,1.25-9.8,4.7-34.64,16.52-.15.08-.08-.15-17.16-34-.09-.17.17-.08h0l48-22.73.14-.06.06.13,12.43,24.81,3.41,6.86.89,1.8.29.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M169.05,369.27c0,.06-.02.12-.04.18-.04.14-.1.31-.17.52-.17.49-.4,1.16-.72,2.01-.63,1.77-1.52,4.27-2.62,7.35l-8.74,24.21-.24.11h-.1l-.12-.03-.23-.08-.46-.15-.91-.29-1.79-.61-3.52-1.14-6.66-2.16-11.27-3.68-7.59-2.51-2.05-.7-.53-.19c-.06-.02-.12-.04-.18-.08.06,0,.13.02.19.04l.55.15,2.08.64,7.63,2.4,11.29,3.57,6.67,2.14,3.53,1.14,1.8.58.91.29.45.15.23.07.12.04h.1c-.1.05.24-.1-.22.12,3.46-9.43,6.6-17.96,8.87-24.17l2.74-7.26c.32-.84.58-1.5.72-1.98l.21-.52.09-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M144.71,399.67c.1,0-1.27,5.99-3.06,13.32s-3.33,13.27-3.44,13.24,1.27-5.99,3.07-13.32c1.79-7.34,3.33-13.27,3.43-13.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M186.72,403.54c-.04.08-5.81-2.65-12.87-6.12-7.07-3.47-12.76-6.35-12.71-6.44s5.81,2.65,12.88,6.12c7.07,3.47,12.74,6.35,12.7,6.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M423.54,407.28s.11-.17.32-.47l.97-1.32,3.67-4.99,13.3-17.97v.21l-37.02-25.94h0l.27-.04-18.4,24.65-.04-.23,26.59,18.77,7.59,5.38,2.02,1.44.52.38c.12.09.18.13.18.14l-.17-.11-.52-.35-2.02-1.4-7.61-5.29-26.77-18.69-.15-.07.1-.14,18.37-24.66.12-.15.15.1h0l36.99,26,.12.08-.09.12-13.47,17.93c-1.61,2.1-2.88,3.78-3.72,4.93-.42.55-.72.98-.97,1.27s-.33.43-.33.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M441.93,382.63c-.21.05-.42.08-.63.1l-1.79.24-6.61.82-21.8,2.58c-.41-.29-.12-.09-.21-.16h0v-.17l-.04-.19-.08-.38-.16-.75c-.11-.5-.21-1.01-.32-1.5-.2-.99-.41-1.97-.61-2.93-.4-1.92-.79-3.78-1.15-5.55-.72-3.49-1.38-6.71-1.92-9.39-.55-2.68-.96-4.81-1.26-6.34l-.32-1.73c-.04-.2-.07-.4-.09-.61.07.19.13.39.17.59.09.42.23.99.4,1.71l1.38,6.29c.57,2.68,1.25,5.85,2,9.38.37,1.77.76,3.62,1.17,5.54.2.96.4,1.94.61,2.93.11.5.21.99.32,1.5l.16.76.08.38.04.2v.17c-.09-.06.21.15-.2-.13l21.82-2.47,6.62-.7,1.8-.17c.21-.02.42-.03.63-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M409.02,376.32c0,.1-5.04,1.31-11.27,2.7-6.22,1.4-11.33,2.45-11.36,2.35s5.04-1.31,11.27-2.7,11.33-2.45,11.35-2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M423.56,407.74c-.1,0-.46-5.11-.79-11.42-.33-6.31-.52-11.43-.41-11.44s.45,5.11.79,11.42c.33,6.31.52,11.43.42,11.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M350.93,535.25l.56.21,1.6.64,6.07,2.46,21.84,8.91-.19.08,18.51-42.39h0l.1.24-30-12.38.22-.09-13.44,30.48c-1.65,3.72-2.95,6.68-3.86,8.71-.45,1-.79,1.77-1.04,2.31l-.27.6-.11.21s0-.07.08-.2.14-.34.24-.59l.99-2.3,3.79-8.71c3.26-7.5,7.88-18.12,13.33-30.65l.06-.15.16.07,29.99,12.32.17.07-.08.17h0c-6.98,15.92-13.43,30.62-18.58,42.37l-.06.13-.14-.06-21.87-9.08-6.01-2.52-1.56-.66-.53-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M380.94,547.61s-.05-.1-.07-.15c-.05-.12-.11-.27-.19-.44-.16-.42-.38-.99-.66-1.71-.58-1.52-1.39-3.66-2.38-6.29l-7.74-20.83c.2-.45.06-.13.11-.23h.05l.09-.04.19-.08.38-.17.76-.33,1.49-.66,2.92-1.28,5.52-2.41,9.36-4.07,6.32-2.71,1.73-.7.45-.17c.11-.04.16-.06.16-.05l-.14.08-.43.21-1.7.78-6.28,2.79-9.36,4.14-5.52,2.43-2.88,1.28-1.5.66-.72.34-.37.16-.19.08-.09.04h-.04c.04-.1-.11.23.09-.22,2.97,8.13,5.67,15.5,7.63,20.86.95,2.65,1.73,4.81,2.28,6.34.25.73.45,1.31.6,1.73.06.18.11.33.15.45,0,.05,0,.1,0,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M379.91,513.82c-.09.04-2.53-4.64-5.43-10.48s-5.18-10.56-5.09-10.61,2.52,4.64,5.42,10.48c2.9,5.84,5.18,10.57,5.09,10.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M350.46,535.38c0-.1,5.23-1.63,11.74-3.42s11.83-3.17,11.83-3.06-5.23,1.63-11.74,3.42c-6.51,1.79-11.81,3.16-11.83,3.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 182.12,
    y: 309.18,
    width: 215.36,
    height: 175.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M182.54,321.29c0-.1,48.03-.18,107.26-.18s107.29.1,107.29.18-48.02.18-107.27.18-107.28-.06-107.28-.18Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 189.09,
    cy: 315.02,
    rx: 2.3,
    ry: 2.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 195.5,
    cy: 315.02,
    rx: 2.3,
    ry: 2.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 202.61,
    cy: 315.02,
    rx: 2.3,
    ry: 2.24
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M435.73,583c0,.1-70.29.18-156.98.18s-157.03-.08-157.03-.18,70.28-.18,157.03-.18,156.98.08,156.98.18Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M389.16,503.44c0-1.28-.06-71.64-.16-180.19l.16.13h-220.96l.19-.18v180.19l-.17-.16,220.98.16-220.98.16h-.19v-180.53h221.33v.15c-.1,108.63-.19,178.99-.19,180.27Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 168.21,
    y: 323.25,
    width: 220.98,
    height: 180.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 168.64,
    y: 335.7,
    width: 79.35,
    height: 17.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M188.65,349.93v-2.42c0-1.57-.04-3.73-.08-6.34l.15.15h-13.16l.19-.18h0v8.74l-.17-.17,9.44.08,2.72.05h.99c-.31.03-.62.05-.93.04l-2.69.04-9.55.08h-.17v-8.85h0c-.17.16.23-.22.19-.18h13.31v.15c0,2.65-.06,4.85-.08,6.43v1.75c-.04.22-.09.43-.17.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M188.65,341.14s-.15.2-.47.52-.79.75-1.37,1.3c-1.17,1.09-2.8,2.58-4.62,4.19-.51,0-.14,0-.26,0h-.04l-.09-.08-.17-.15-.34-.3-.65-.59-1.23-1.11-2.1-1.97c-.58-.54-1.05-.99-1.38-1.3-.18-.15-.34-.33-.47-.52,0,0,.22.13.57.41s.84.7,1.44,1.22l2.12,1.84,1.24,1.1.66.58.34.3.17.15.09.07.04.04h-.23c1.82-1.62,3.47-3.08,4.69-4.12.61-.52,1.1-.94,1.44-1.22.18-.15.39-.28.61-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M179.87,345.04c-.59.93-1.28,1.79-2.06,2.56-.69.86-1.47,1.64-2.34,2.33.59-.92,1.28-1.78,2.06-2.56.69-.86,1.47-1.64,2.34-2.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M188.74,350.01c-.85-.73-1.61-1.56-2.28-2.45-.76-.82-1.43-1.73-1.99-2.69.85.74,1.61,1.56,2.28,2.46.76.82,1.43,1.72,1.99,2.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M238.88,344.21c0,.1-9.29.18-20.74.18s-20.74-.08-20.74-.18,9.28-.18,20.74-.18,20.74.08,20.74.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 246.98,
    y: 414.06,
    width: 142.21,
    height: 30.22
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 246.98,
    y: 414.06,
    width: 142.21,
    height: 30.22
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 256.13,
    y: 423.51,
    width: 11.68,
    height: 11.33,
    rx: 2.25,
    ry: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M261.09,431.68c-.16,0-.31-.05-.43-.14l-2.36-1.72c-.34-.2-.44-.63-.23-.96.21-.33.65-.43.99-.22.04.02.07.05.1.08l1.84,1.33,3.69-3.88c.27-.28.73-.3,1.02-.04.29.26.31.71.04.99h0l-4.13,4.35c-.14.14-.33.22-.53.22Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 246.98,
    y: 383.68,
    width: 142.21,
    height: 30.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M388.33,414.02c0,.1-31.42.18-70.17.18s-70.17-.08-70.17-.18,31.41-.18,70.17-.18,70.17.08,70.17.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 247.06,
    y: 474.48,
    width: 142.21,
    height: 28.96
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 247.06,
    y: 474.48,
    width: 142.21,
    height: 28.96
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 256.2,
    y: 483.93,
    width: 11.68,
    height: 11.33,
    rx: 2.25,
    ry: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M261.16,492.12c-.16,0-.31-.05-.43-.14l-2.36-1.72c-.32-.23-.38-.67-.14-.98.24-.31.69-.37,1.01-.14l1.84,1.34,3.69-3.88c.25-.3.7-.35,1.01-.11.31.24.36.68.11.98-.02.02-.04.05-.06.07l-4.15,4.35c-.13.14-.32.22-.51.22Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 246.98,
    y: 383.68,
    width: 142.21,
    height: 30.22
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 256.13,
    y: 393.13,
    width: 11.68,
    height: 11.33,
    rx: 2.25,
    ry: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M261.09,401.31c-.16,0-.31-.05-.43-.14l-2.36-1.72c-.34-.2-.44-.63-.23-.96.21-.33.65-.43.99-.22.04.02.07.05.1.08l1.84,1.33,3.69-3.88c.27-.28.72-.3,1.02-.04.29.26.32.7.05.99,0,0,0,0,0,0l-4.13,4.35c-.14.14-.33.22-.53.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M389.16,503.44c0-1.28-.06-71.64-.16-180.19l.16.13h-220.96l.19-.18v180.19l-.17-.16,220.98.16-220.98.16h-.19v-180.53h221.33v.15c-.1,108.63-.19,178.99-.19,180.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M168.64,335.7c0-.1,49.28-.18,110.05-.18s110.07.08,110.07.18-49.27.18-110.07.18-110.05-.08-110.05-.18Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-41",
    cx: 175.37,
    cy: 329.24,
    rx: 2.36,
    ry: 2.29
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-41",
    cx: 181.94,
    cy: 329.24,
    rx: 2.36,
    ry: 2.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M190.9,327.62c.92.9.92,2.35,0,3.24-.92.89-2.42.89-3.34,0-.92-.89-.92-2.35,0-3.24.92-.9,2.42-.9,3.34,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M197.56,360.41c.17-.02.34-.02.51,0l1.5-.04,5.49-.07h.07l.04.06,2.42,3.09.04.05v4.79h-12.43v-.19c0-1.58,0-2.98.04-4.19h0l1.69-2.56c.19-.32.4-.63.63-.93-.03.09-.07.18-.13.27l-.41.7-1.56,2.58v-.06c0,1.19,0,2.59.04,4.19l-.16-.15h12.09l-.19.18v-4.56l.04.1-2.38-3.11.12.06-5.43-.07h-1.51c-.18-.02-.35-.06-.53-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M207.47,363.75c-.34.09-.69.14-1.04.14-.66.06-1.61.12-2.74.19l.15-.15c-.03.58-.22,1.15-.57,1.63-.19.26-.43.48-.72.64-.32.14-.66.22-1.01.23-.75.03-1.48-.27-1.98-.81-.41-.48-.69-1.05-.81-1.67l.16.13c-1.05,0-1.93-.03-2.54-.06-.32,0-.64-.03-.96-.1.31-.07.64-.09.96-.08.61,0,1.49-.05,2.54-.07h.1v.13c.12.55.38,1.06.76,1.48.43.47,1.05.72,1.7.7.29,0,.58-.07.85-.19.25-.13.47-.3.63-.52.31-.42.49-.92.53-1.43v-.15h.14c1.14-.03,2.09-.06,2.76-.06.37-.03.73-.02,1.09.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M234.54,360.8c.2-.04.41-.06.61-.06v.11c-1.44.07-5.9.13-11.13.13-3.24,0-6.18,0-8.31-.06l-2.51-.06c-.31.01-.62-.01-.92-.07.3-.06.61-.08.92-.07l2.51-.06c2.12-.03,5.04-.06,8.31-.06,5.23,0,9.66.06,11.13.13v.11c-.21.01-.41,0-.61-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M234.54,365.38c.2-.05.41-.07.61-.06v.11c-1.44.07-5.9.13-11.13.13-3.24,0-6.18,0-8.31-.06l-2.51-.06c-.31,0-.62-.02-.92-.07.3-.06.61-.08.92-.08l2.51-.06c2.12,0,5.04-.05,8.31-.05,5.23,0,9.66.05,11.13.13v.11c-.21,0-.41-.02-.61-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M234.54,369.94c.2-.04.41-.06.61-.06v.11c-1.44.08-5.9.13-11.13.13-3.24,0-6.18,0-8.31-.05l-2.51-.06c-.31.01-.62-.01-.92-.07.3-.05.61-.08.92-.07l2.51-.06c2.12-.03,5.04-.06,8.31-.06,5.23,0,9.66.06,11.13.13v.11c-.21.01-.41,0-.61-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M197.56,393.16c.17-.03.34-.05.51-.04l1.5-.03,5.49-.07h.07l.04.06,2.42,3.09.04.05v4.79h-12.43v-.15c0-1.58,0-2.98.04-4.19v-.03h0l1.69-2.56c.18-.3.39-.59.61-.87-.03.09-.07.18-.13.27l-.41.7-1.53,2.59v-.06c0,1.19,0,2.59.04,4.19l-.16-.15h12.09l-.19.18v-4.56l.04.1-2.38-3.11.12.06-5.43-.07h-1.51c-.18-.04-.36-.09-.53-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M207.47,396.48c-.34.09-.69.14-1.04.14-.66.06-1.61.12-2.74.19l.15-.15c-.03.58-.22,1.15-.57,1.63-.19.26-.43.48-.72.64-.32.14-.66.22-1.01.23-.75.03-1.48-.27-1.98-.81-.41-.48-.69-1.05-.81-1.67l.16.13c-1.05,0-1.93-.03-2.54-.06-.32.01-.64-.02-.96-.09.31-.07.64-.1.96-.09l2.54-.06h.1v.13c.12.55.38,1.06.76,1.48.43.47,1.05.72,1.7.7.29,0,.58-.07.85-.19.25-.13.47-.3.63-.52.31-.42.49-.92.53-1.43v-.15h.14c1.14,0,2.09-.06,2.76-.06.36-.04.73-.03,1.09.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M234.54,393.53c.2-.04.41-.06.61-.06v.11c-1.44.07-5.9.13-11.13.13-3.24,0-6.18,0-8.31-.06l-2.51-.06c-.31.01-.62-.01-.92-.07.3-.06.61-.08.92-.07l2.51-.06c2.12-.03,5.04-.06,8.31-.06,5.23,0,9.66.06,11.13.13v.11c-.21,0-.41-.01-.61-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M234.54,398.1c.2-.05.41-.07.61-.06v.1c-1.44.07-5.9.13-11.13.13-3.24,0-6.18,0-8.31-.06l-2.51-.06c-.31,0-.62-.02-.92-.07.3-.06.61-.08.92-.08l2.51-.06c2.12-.03,5.04-.05,8.31-.05,5.23,0,9.66.05,11.13.13v.11c-.21,0-.41,0-.61-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M234.54,402.67c.2-.04.41-.06.61-.06v.11c-1.44.08-5.9.13-11.13.13-3.24,0-6.18,0-8.31-.05l-2.51-.06c-.31.01-.62-.01-.92-.07.3-.05.61-.08.92-.07l2.51-.06c2.12-.03,5.04-.06,8.31-.06,5.23,0,9.66.06,11.13.13v.11c-.21.01-.41,0-.61-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M197.56,425.89c.17-.03.34-.05.51-.04l1.5-.03,5.49-.07h.07l.04.06,2.42,3.09.04.05v4.79h-12.43v-.15c0-1.58,0-2.98.04-4.19h0l1.69-2.56c.18-.3.39-.59.61-.87-.03.09-.07.18-.13.27l-.41.7-1.56,2.58v-.06c0,1.19,0,2.59.04,4.19l-.16-.15h12.09l-.19.18v-4.56l.04.1-2.38-3.11.12.06-5.43-.07h-1.51c-.17-.05-.34-.11-.5-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M207.47,429.21c-.34.09-.69.14-1.04.14-.66.06-1.61.12-2.74.19l.15-.15c-.03.58-.22,1.15-.57,1.63-.19.26-.43.48-.72.64-.32.14-.66.22-1.01.22-.75.04-1.48-.26-1.98-.8-.41-.48-.69-1.05-.81-1.67l.16.13c-1.05,0-1.93,0-2.54-.06-.32.01-.64-.02-.96-.09.31-.07.64-.1.96-.09l2.54-.06h.1v.13c.12.55.38,1.06.76,1.48.43.47,1.05.72,1.7.7.29,0,.58-.07.85-.19.25-.13.47-.3.63-.52.31-.42.49-.92.53-1.43v-.15h.14c1.14-.04,2.09-.06,2.76-.06.36-.04.73-.03,1.09.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M234.54,426.25c.2-.04.41-.06.61-.06v.11c-1.44.07-5.9.13-11.13.13-3.24,0-6.18,0-8.31-.06l-2.51-.06c-.31.01-.62-.01-.92-.07.3-.06.61-.08.92-.07l2.51-.06c2.12-.03,5.04-.06,8.31-.06,5.23,0,9.66.06,11.13.13v.11c-.21,0-.41-.01-.61-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M234.54,430.83c.2-.05.41-.07.61-.06v.11c-1.44.07-5.9.13-11.13.13-3.24,0-6.18,0-8.31-.06l-2.51-.06c-.31,0-.62-.02-.92-.07.3-.06.61-.08.92-.08l2.51-.06c2.12-.03,5.04-.05,8.31-.05,5.23,0,9.66.05,11.13.13v.11c-.21,0-.41-.02-.61-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M234.54,435.4c.2-.04.41-.06.61-.06v.11c-1.44.08-5.9.13-11.13.13-3.24,0-6.18,0-8.31-.05l-2.51-.06c-.31.01-.62-.01-.92-.07.3-.05.61-.08.92-.07l2.51-.06c2.12,0,5.04-.06,8.31-.06,5.23,0,9.66.06,11.13.13v.11c-.21.01-.41,0-.61-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M377.72,404.82h-5.49c-1.19.02-2.18-.9-2.2-2.06,0-.01,0-.02,0-.04v-8.87h.72v8.85c0,.77.64,1.4,1.44,1.4.01,0,.02,0,.04,0h5.49c.8,0,1.44-.63,1.44-1.4v-8.54h.72v8.54c.02,1.16-.94,2.11-2.13,2.12,0,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 369.14,
    y: 393.9,
    width: 11.68,
    height: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M372.86,394.24h-.72v-.78c0-.77.64-1.4,1.44-1.4h2.88c.8,0,1.44.63,1.44,1.4v.62h-.72v-.62c0-.39-.32-.7-.72-.7h-2.88c-.4,0-.72.31-.72.7v.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M373.32,402.2c-.18-.99-.25-2-.19-3-.06-1,0-2.01.19-3,.19.99.25,1.99.19,3,.06,1.01,0,2.01-.19,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M375.01,402.2c-.18-.99-.25-2-.19-3-.06-1,0-2.01.19-3,.19.99.25,1.99.19,3,.06,1.01,0,2.01-.19,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M376.72,402.2c-.18-.99-.25-2-.19-3-.06-1,0-2.01.19-3,.19.99.25,1.99.19,3,.06,1.01,0,2.01-.19,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M377.72,433.46h-5.49c-1.21,0-2.19-.96-2.2-2.13v-8.85h.72v8.85c0,.79.66,1.43,1.48,1.43h5.49c.8-.02,1.44-.65,1.44-1.43v-8.54h.72v8.54c.02,1.16-.93,2.11-2.12,2.13-.01,0-.02,0-.04,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 369.14,
    y: 422.53,
    width: 11.68,
    height: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M372.86,422.88h-.72v-.78c0-.77.64-1.4,1.44-1.4h2.88c.8,0,1.44.63,1.44,1.4v.62h-.72v-.62c0-.39-.32-.7-.72-.7h-2.88c-.4,0-.72.31-.72.7v.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M373.32,430.84c-.25-1.99-.25-4.01,0-6,.25,1.99.25,4.01,0,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M375.01,430.84c-.25-1.99-.25-4.01,0-6,.25,1.99.25,4.01,0,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M376.72,430.84c-.25-1.99-.25-4.01,0-6,.25,1.99.25,4.01,0,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M377.72,496.42h-5.49c-1.19.02-2.18-.9-2.2-2.06,0-.01,0-.02,0-.04v-8.85h.72v8.85c0,.77.64,1.4,1.44,1.4.01,0,.02,0,.04,0h5.49c.8,0,1.44-.63,1.44-1.4v-8.57h.72v8.54c.02,1.16-.94,2.11-2.13,2.12,0,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 369.14,
    y: 485.5,
    width: 11.68,
    height: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M372.86,485.85h-.72v-.78c0-.77.64-1.4,1.44-1.4h2.88c.8,0,1.44.63,1.44,1.4v.63h-.72v-.63c0-.39-.32-.7-.72-.7h-2.88c-.4,0-.72.31-.72.7v.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M373.32,493.81c-.25-1.99-.25-4.01,0-6,.25,1.99.25,4.01,0,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M375.01,493.81c-.25-1.99-.25-4.01,0-6,.25,1.99.25,4.01,0,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M376.72,493.81c-.25-1.99-.25-4.01,0-6,.25,1.99.25,4.01,0,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M380.71,371.8c-.03-.22-.04-.43-.04-.65v-1.78c0-1.56-.05-3.72-.08-6.34l.15.15-13.19.03.19-.18h0v8.73l-.17-.17,9.44.08,2.73.04h.99c-.31.02-.62.02-.93,0l-2.69.05-9.55.08h-.17v-8.9h0c-.17.16.23-.22.19-.19l13.17.04h.15v.14c0,2.65-.06,4.86-.07,6.43,0,.7,0,1.31-.04,1.75,0,.23-.03.45-.06.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M380.71,363.03c-.13.19-.29.37-.47.52-.32.31-.79.76-1.38,1.31-1.17,1.09-2.79,2.57-4.62,4.19h-.26l-.04-.04-.08-.08-.17-.15-.33-.3-.66-.59-1.22-1.11-2.07-1.9c-.58-.54-1.05-.99-1.37-1.31-.18-.15-.34-.33-.47-.52.2.12.4.26.57.41.35.29.84.7,1.44,1.22l2.12,1.84,1.25,1.1.66.59.33.29.17.15.09.08h.04c-.12,0,.26,0-.25,0,1.82-1.63,3.48-3.08,4.69-4.12.61-.52,1.11-.94,1.44-1.22.18-.15.38-.27.59-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M371.93,366.95c-.59.92-1.29,1.77-2.07,2.54-.69.86-1.47,1.64-2.34,2.33.58-.93,1.27-1.79,2.06-2.56.69-.85,1.48-1.63,2.35-2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M380.79,371.9c-.85-.74-1.61-1.56-2.28-2.45-.76-.82-1.42-1.72-1.98-2.68.85.74,1.61,1.56,2.28,2.45.76.82,1.43,1.72,1.98,2.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M388.33,353.34c0,.1-31.42.18-70.17.18s-70.18-.09-70.18-.18,31.41-.18,70.17-.18,70.18.08,70.18.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M388.33,383.68c0,.1-31.42.18-70.17.18s-70.18-.08-70.18-.18,31.41-.18,70.17-.18,70.18.08,70.18.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M388.33,443.74c0,.1-31.42.18-70.17.18s-70.18-.08-70.18-.18,31.41-.18,70.17-.18,70.18.08,70.18.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M388.33,474.48c0,.1-31.42.18-70.17.18s-70.17-.08-70.17-.18,31.41-.18,70.17-.18,70.17.08,70.17.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M266.19,374.39s.16,0,.43-.1c.4-.12.73-.39.92-.75.28-.45.14-1.13.16-1.9s0-1.64,0-2.6v-4.02c.02-.28,0-.56-.07-.83-.19-.55-.7-.93-1.29-.96h-8.59c-.69,0-1.28.48-1.4,1.14-.05.64,0,1.4,0,2.1v5.87c-.02.28,0,.57.04.85.06.26.2.51.4.7.19.18.42.3.68.36.26.04.52.06.79.04h1.56l4.7.06,1.28.03c.15,0,.3,0,.45.03-.15.02-.3.02-.45,0l-1.28.03-4.7.06h-1.56c-.29.02-.57,0-.86-.04-.64-.14-1.15-.62-1.31-1.24-.06-.3-.08-.61-.06-.92v-6.92c-.02-.37-.02-.73,0-1.1.17-.81.91-1.4,1.77-1.4h8.56c.73.05,1.35.52,1.58,1.19.08.31.11.62.09.94v7.69c0,.31-.07.63-.22.9-.23.37-.6.64-1.03.75-.18.06-.38.07-.57.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M266.19,465.06s.16,0,.43-.1c.4-.12.73-.39.92-.75.28-.45.14-1.13.16-1.9s0-1.64,0-2.6v-4.02c.02-.28,0-.56-.07-.83-.19-.55-.7-.93-1.29-.96h-8.59c-.69,0-1.27.48-1.4,1.13-.05.65,0,1.4,0,2.1v5.86c-.02.28,0,.57.04.85.06.27.2.51.4.7.19.18.42.3.68.36.26.05.52.07.79.05h1.56l4.7.06,1.28.03c.15-.01.3-.01.45,0-.15.03-.3.04-.45.03l-1.28.03-4.7.06h-1.56c-.29.02-.57,0-.86-.04-.64-.14-1.15-.62-1.31-1.24-.06-.31-.08-.62-.06-.93v-6.91c-.02-.37-.02-.73,0-1.1.16-.83.9-1.43,1.77-1.43h8.56c.73.05,1.35.52,1.58,1.19.08.31.11.62.09.94v7.69c0,.31-.07.63-.22.9-.22.37-.6.64-1.03.75-.18.07-.38.09-.57.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M246.95,500.85v-24.19c0-14.94.19-35.58.4-58.37.22-22.8.38-43.43.52-58.38.05-7.46.09-13.51.12-17.7,0-2.1,0-3.7.04-4.81v-1.68,24.18c-.04,14.94-.19,35.58-.41,58.38-.22,22.8-.38,43.42-.51,58.37-.05,7.46-.09,13.51-.12,17.7,0,2.1,0,3.7-.04,4.81v1.25c0,.3,0,.43,0,.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M327.15,395.85c0,.1-10.8.18-24.17.18s-24.17-.08-24.17-.18,10.8-.18,24.17-.18,24.17.08,24.17.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M357.37,401.02c0,.1-17.59.18-39.28.18s-39.29-.08-39.29-.18,17.59-.18,39.29-.18,39.28.1,39.28.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M327.15,456.71c0,.1-10.8.18-24.17.18s-24.17-.08-24.17-.18,10.8-.18,24.17-.18,24.17.08,24.17.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M357.37,461.88c0,.1-17.59.18-39.28.18s-39.29-.08-39.29-.18,17.59-.18,39.29-.18,39.28.08,39.28.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M327.15,366.61c0,.1-10.8.19-24.17.19s-24.17-.08-24.17-.19,10.8-.18,24.17-.18,24.17.08,24.17.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M357.37,371.78c0,.1-17.59.18-39.28.18s-39.29-.08-39.29-.18,17.59-.18,39.29-.18,39.28.08,39.28.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M327.15,425.67c0,.1-10.8.18-24.17.18s-24.17-.08-24.17-.18,10.8-.18,24.17-.18,24.17.08,24.17.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M357.37,430.84c0,.1-17.59.18-39.28.18s-39.29-.08-39.29-.18,17.59-.18,39.29-.18,39.28.08,39.28.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M327.15,485.59c0,.1-10.8.18-24.17.18s-24.17-.08-24.17-.18,10.8-.18,24.17-.18,24.17.07,24.17.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M357.37,490.76c0,.1-17.59.18-39.28.18s-39.29-.08-39.29-.18,17.59-.18,39.29-.18,39.28.08,39.28.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 372.5,
    y: 339.5,
    width: 9.52,
    height: 9.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 357,
    y: 339.5,
    width: 9.52,
    height: 9.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 341.51,
    y: 339.5,
    width: 9.52,
    height: 9.23
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "178.32 363.67 182.36 368.79 185.82 363.67 178.32 363.67"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M169.56,430.01c9.36-11.99,19.28-10.3,26.14-7.4,7,3.1,11.37,10.01,11.02,17.47-.12,1.91-.54,3.93.27,5.68,1.29,2.79,5.04,3.61,7.2,5.86,2.97,3.08,2.32,7.95,1.31,12.06s-2.06,8.79.42,12.25c2.28,3.17,6.63,4.02,10.21,5.71,4.81,2.23,8.42,6.34,9.91,11.31,1.42,5.02.14,10.39-3.39,14.31-3.49,3.68-8.72,5.31-13.81,6.04-27.8,3.98-53.66-14.65-57.76-41.61-.49-3.21-.65-6.47-.48-9.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M196.19,423.12c-1.11,0-2.23.05-3.33.18-2.65.5-5.24,1.23-7.75,2.18-2.99,1.01-5.88,1.58-7.98,1.45-.83-.03-1.65-.16-2.44-.38-.3-.07-.58-.18-.85-.33,1.08.26,2.19.42,3.3.46,2.69-.08,5.35-.6,7.86-1.54,2.97-1.01,5.76-1.89,7.83-2.1.82-.1,1.65-.12,2.48-.06.3,0,.6.06.89.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M217.77,518.48c.36,1.05,7.83,35.28,7.83,35.28l56.82,21.19-3.2,8.04-48.72-4.16h0c-28.44-4.12-30.01-17.65-28.3-32.77l2.95-25.93,12.62-1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M136.1,500.02c5.86-8.6,14.74-13.56,22.88-16.31l29.89,2.1c6.77-.57,13.44,1.82,18.21,6.52l2.78,71.84,6.86,18.86h-71.12l-9.52-83.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M208.18,521.81s-.06-.03-.17-.11l-.48-.35c-.25-.2-.51-.39-.79-.57l-1.12-.7c-.45-.23-.94-.49-1.48-.75-2.07-.92-4.28-1.48-6.55-1.67-1.94-.17-3.9-.05-5.81.35-2.19.45-4.27,1.3-6.13,2.5-2.1,1.27-3.77,3.09-4.83,5.26-.53,1.14-.75,2.39-.66,3.64.13,1.28.63,2.51,1.44,3.53.8,1.02,1.98,1.7,3.28,1.89,1.26.22,2.53-.31,3.23-1.35.54-1.08.56-2.33.06-3.42-.21-.55-.5-1.06-.85-1.54-.35-.46-.76-.88-1.2-1.26-1.68-1.43-3.71-2.42-5.9-2.86-1.91-.41-3.87-.51-5.81-.31-2.82.33-5.59.97-8.27,1.9l-2.2.7-.57.18c-.06.03-.13.04-.2.05l.19-.08.56-.22c.49-.18,1.22-.45,2.16-.78,2.67-.98,5.45-1.66,8.28-2.01,1.97-.22,3.96-.13,5.9.27,2.24.44,4.33,1.45,6.06,2.91.23.2.45.41.66.62.22.22.42.45.6.7.37.5.67,1.04.9,1.61.54,1.19.51,2.56-.08,3.73-.35.59-.9,1.04-1.55,1.29-.65.25-1.35.33-2.05.24-1.41-.2-2.68-.92-3.54-2.03-.85-1.08-1.37-2.37-1.49-3.72-.1-1.31.15-2.62.72-3.81,1.08-2.23,2.81-4.1,4.97-5.4,1.9-1.22,4.03-2.07,6.26-2.52,1.94-.39,3.92-.49,5.89-.31,1.62.14,3.22.48,4.75,1.02.63.22,1.24.47,1.84.75.55.27,1.04.54,1.44.78l1.11.73c.27.19.52.39.77.6l.45.38.16.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "207.09 492.3 224.73 523.08 205.15 528.91 207.09 492.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M209.46,564.38c-.03-.18-.05-.36-.06-.54,0-.38-.05-.89-.09-1.54-.06-1.4-.15-3.31-.27-5.69-.2-4.79-.45-11.42-.68-18.75s-.36-13.97-.4-18.77v-7.23c0-.18,0-.36.04-.54.03.18.05.36.04.54l.04,1.54c0,1.4.07,3.31.13,5.68.13,4.83.31,11.45.51,18.76s.42,13.92.57,18.75c.06,2.37.11,4.3.14,5.69v1.54c.03.18.03.36.02.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M212.29,501.67c-.12.11-.26.2-.4.27-.4.24-.81.46-1.24.66-4.05,1.73-8.73,1.35-12.43-1.01-.64-.39-1.22-.86-1.72-1.4-.56-.58-.93-1.31-1.07-2.1-.16-.83.08-1.68.64-2.33.63-.64,1.56-.9,2.44-.7.87.16,1.64.66,2.11,1.4.41.73.55,1.57.38,2.38-.15.77-.49,1.49-1,2.1-.49.57-1.09,1.05-1.76,1.4-1.25.61-2.61.97-4,1.09-1.2.13-2.4.15-3.6.04-1.73-.15-3.43-.55-5.04-1.18-.44-.17-.87-.36-1.28-.58-.15-.06-.3-.15-.42-.24.15.05.31.11.45.18.3.13.72.31,1.3.51,1.62.58,3.32.93,5.04,1.06,1.18.09,2.37.06,3.54-.08,1.35-.12,2.66-.49,3.87-1.08.63-.33,1.2-.78,1.66-1.31.46-.57.78-1.23.91-1.94.15-.73.03-1.48-.35-2.13-.41-.65-1.09-1.09-1.86-1.23-.75-.18-1.55.04-2.1.57-.49.56-.69,1.31-.55,2.03.13.71.46,1.37.97,1.9.48.54,1.04,1.01,1.65,1.4,2.11,1.38,4.61,2.11,7.16,2.1,1.73,0,3.44-.31,5.04-.94,1.07-.49,1.63-.86,1.65-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M208.53,563.78l-.2-.13-.58-.41c-.75-.51-1.54-.96-2.36-1.36-3.02-1.45-6.36-2.17-9.72-2.1-4.24,0-9.26,1.4-14.13,4.11-1.25.68-2.42,1.49-3.49,2.42-1.12.94-2.06,2.08-2.75,3.35-.71,1.32-.94,2.82-.66,4.28.17.73.55,1.39,1.11,1.9.55.51,1.34.7,2.07.5.72-.24,1.32-.74,1.66-1.4.37-.66.57-1.39.6-2.14-.01-1.5-.49-2.96-1.37-4.19-.84-1.19-1.92-2.2-3.19-2.96-1.22-.72-2.56-1.23-3.95-1.5-2.62-.47-5.3-.5-7.92-.08-2.3.32-4.57.8-6.79,1.44-3.22.95-6.33,2.23-9.28,3.8-1.04.55-1.84,1.01-2.38,1.33l-.61.36-.22.11s.06-.06.19-.15l.59-.39c.52-.34,1.31-.81,2.35-1.4,2.94-1.61,6.06-2.9,9.28-3.86,2.23-.66,4.52-1.16,6.83-1.49,2.66-.45,5.37-.43,8.02.04,1.44.28,2.82.8,4.07,1.54,1.31.78,2.44,1.81,3.31,3.05.92,1.28,1.42,2.8,1.44,4.37-.03.81-.25,1.6-.65,2.31-.39.75-1.07,1.33-1.89,1.6-.86.24-1.78.02-2.43-.57-.61-.57-1.03-1.3-1.22-2.1-.29-1.54-.04-3.14.72-4.53.71-1.31,1.68-2.49,2.84-3.46,1.1-.93,2.29-1.76,3.56-2.45,4.91-2.74,10-4.07,14.3-4.07,3.4-.05,6.77.7,9.8,2.21,1.1.54,2.11,1.21,3.03,2.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M157.79,507.98c-2.16-10.74-17.83-11.14-20.57-.52-.04.16-.09.33-.12.5-4.04,16.72,9.61,66.12,13.28,68.97,3.67,2.85,7.3,6.08,13.57,3.56,3.67-1.47,41.73-34.11,41.73-34.11,0,0,8.8,8.18,11.74,7.47,2.94-.71,8.54-9.08,8.54-9.08,0,0,5.45,7.92,6.13,8.03,1.11.18,2.17-.56,2.35-1.64.07-.41,0-.83-.19-1.21-.72-1.07-7.66-15.79-7.66-15.79,0,0,5.47-.57,4.37-2.35,0,0-.14-1.63-3.83-1.32s-3.62-3.78-10.5-3.39c-6.88.39-21.08,2.1-41.06,16.96l-9.26,6.33-8.51-42.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M175.54,544.06l.23-.18.72-.51,2.7-1.96c3.43-2.38,7.01-4.57,10.7-6.54,5.66-3.04,11.71-5.31,18.01-6.75,1.82-.37,3.7-.7,5.65-.92.98-.1,1.97-.19,2.97-.26,1.03-.07,2.06-.03,3.08.13,1.05.18,2.05.56,2.95,1.11.91.54,1.69,1.29,2.61,1.75.45.23.94.35,1.44.37.51,0,1.07-.06,1.64-.04.57,0,1.14.09,1.68.28.61.17,1.08.64,1.24,1.23v-.07c.15.22.2.49.14.75-.08.25-.24.47-.45.62-.4.28-.84.5-1.31.64-.94.29-1.9.49-2.88.59l.15-.24,4.88,10.25c.86,1.75,1.71,3.54,2.64,5.28.15.22.27.45.35.7.05.27.05.54,0,.81-.09.55-.38,1.04-.82,1.4-.44.36-1.01.53-1.58.47h-.21c-.05,0-.1-.03-.15-.05l-.1-.07c-.11-.09-.21-.18-.3-.29-.18-.19-.35-.38-.51-.59-1.88-2.33-3.54-4.75-5.2-7.13h.31c-1.3,1.93-2.72,3.78-4.24,5.55-.74.88-1.56,1.7-2.43,2.45-.22.18-.46.35-.68.53-.25.16-.5.31-.76.44-.55.29-1.19.34-1.78.14-1.09-.34-2.13-.83-3.07-1.46-.94-.59-1.84-1.23-2.71-1.89-1.73-1.32-3.35-2.7-4.89-4.11h.23c-12.07,10.3-22.41,18.95-29.8,24.94-3.7,3-6.66,5.32-8.73,6.86-1.04.77-1.85,1.34-2.42,1.7-.28.19-.58.35-.9.48,0,0,.32-.15.87-.53s1.36-.95,2.38-1.73c2.05-1.56,4.98-3.91,8.64-6.93,7.35-6.04,17.66-14.72,29.71-25.04l.12-.1.12.1c1.53,1.4,3.15,2.79,4.88,4.07.86.65,1.75,1.29,2.68,1.87.91.6,1.91,1.08,2.96,1.4,1.08.39,2.05-.35,2.88-1.04.85-.75,1.65-1.55,2.38-2.41,1.51-1.76,2.91-3.6,4.21-5.51l.15-.23.16.22c1.65,2.37,3.33,4.79,5.18,7.11.16.2.33.38.5.57.09.08.17.17.26.24l.06.04h0v.06c0,.06,0,.11,0-.06h.17c.47.05.95-.09,1.31-.38.78-.59.94-1.67.36-2.45-.96-1.78-1.79-3.56-2.65-5.31l-4.88-10.26-.1-.22h.24c.95-.11,1.89-.3,2.8-.58.43-.12.84-.32,1.2-.57.15-.11.27-.26.33-.44.03-.17,0-.35-.1-.5h0v-.05c-.15-.46-.54-.81-1.02-.94-.5-.17-1.03-.25-1.56-.25-.54,0-1.06.05-1.64.04-.57-.02-1.12-.16-1.63-.42-.99-.5-1.75-1.24-2.63-1.77-.86-.53-1.82-.89-2.82-1.07-2-.35-4.02-.05-5.96.12s-3.81.53-5.62.89c-6.29,1.41-12.34,3.65-18.01,6.65-3.7,1.95-7.28,4.1-10.74,6.44l-2.72,1.92-.72.49-.17.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M162.88,562.4s-.08-.18-.15-.52c-.1-.48-.16-.97-.18-1.46-.19-3.27.74-6.5,2.64-9.21.28-.41.6-.79.94-1.16.24-.25.39-.38.4-.37s-.45.63-1.12,1.67c-1.74,2.73-2.65,5.88-2.61,9.08.01,1.19.14,1.96.07,1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M147.14,489.4c-.35.23-13.03,3.91-15.03,16.51s-.82,34.56-.82,34.56l34.39-2.29-9.86-44.31-8.68-4.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M220.21,552.1c-.06,0,.04-.45,0-1.15-.04-.91-.28-1.79-.72-2.59-.44-.8-1.06-1.5-1.81-2.04-.58-.41-1-.57-.98-.64.41.05.8.19,1.13.43.84.52,1.53,1.24,1.99,2.1.47.86.69,1.82.64,2.79,0,.38-.08.76-.25,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M223.37,548.36c-.33-2.18-1.61-4.13-3.52-5.34.34.06.66.2.93.41.69.44,1.28,1.02,1.73,1.7.45.68.75,1.44.87,2.24.08.32.08.66-.01.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M223.37,540.39s.32.1.72.45c1.03.92,1.62,2.22,1.63,3.58,0,.51-.09.82-.14.81-.1-.9-.32-1.77-.64-2.62-.43-.8-.96-1.54-1.57-2.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M161.49,517.25c-.06.01-.12.01-.18,0l-.52-.06c-.66-.08-1.33-.12-2-.13-2.46-.02-4.91.41-7.2,1.29-3.41,1.29-6.34,3.54-8.41,6.47-1.23,1.69-1.86,3.72-1.8,5.79.05,1.09.38,2.14.97,3.07.61.94,1.54,1.64,2.64,1.98,1.09.35,2.27.3,3.31-.15,1-.46,1.73-1.33,2.02-2.36.24-1.02.19-2.08-.13-3.08-.29-.97-.76-1.88-1.37-2.69-2.2-2.85-5.48-4.73-9.11-5.23-2.44-.31-4.93.01-7.2.94-.62.25-1.21.55-1.79.87l-.45.27-.16.08c.72-.55,1.5-1,2.34-1.34,2.28-.99,4.81-1.36,7.29-1.06,3.73.46,7.1,2.36,9.36,5.27.65.84,1.13,1.79,1.44,2.79.35,1.06.39,2.19.14,3.27-.31,1.14-1.12,2.09-2.21,2.6-1.14.49-2.42.55-3.6.17-1.17-.38-2.17-1.15-2.82-2.17-.63-.97-.99-2.08-1.05-3.22-.05-2.15.63-4.26,1.92-6.01,2.12-2.97,5.12-5.24,8.6-6.52,2.32-.86,4.8-1.27,7.28-1.19.91.02,1.81.13,2.69.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M160.32,499.15c-.28.16-.57.29-.87.39-.35.15-.7.27-1.07.37-.47.16-.95.29-1.44.39-.59.14-1.18.25-1.78.33-.65.1-1.34.14-2.07.19-1.59.05-3.18-.06-4.75-.31-1.56-.29-3.09-.73-4.57-1.31-.67-.29-1.31-.56-1.87-.87-.54-.27-1.06-.58-1.56-.91-.42-.26-.82-.55-1.21-.85-.3-.21-.59-.45-.86-.7-.25-.2-.48-.42-.68-.66.05-.06,1.04.87,2.88,2,.51.31,1.03.6,1.57.85.6.31,1.22.59,1.86.84,2.91,1.15,6.04,1.69,9.18,1.6.72-.04,1.44-.06,2.05-.15s1.22-.17,1.76-.28c2.14-.44,3.4-.98,3.43-.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M163.15,520.52c.04.11.06.22.08.34.04.25.1.57.17.97.14.89.34,2.1.58,3.65.47,3.17,1.12,7.56,1.88,12.66v.19h-.19l-8.04.54-18.64,1.19-5.65.32-1.54.07h-.5c.17-.05.35-.07.53-.08l1.53-.13,5.65-.43,18.63-1.3,8.03-.52-.17.2c-.72-5.11-1.31-9.51-1.74-12.67-.2-1.54-.36-2.79-.48-3.67-.05-.41-.09-.7-.12-.99-.02-.11-.03-.22-.01-.34Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.48,489.05c-.35,1.18.62,2.28,1.25,3.35,1.21,2.04,1.27,4.51,1.38,6.86.08,4.33.77,8.62,2.04,12.77,1.38,4.09,3.76,7.97,7.28,10.61s8.23,3.93,12.53,2.85c4.3-1.08,7.92-4.79,8.29-9.08s-2.3-8.13-3.83-12.14c-1.18-3.09-1.71-6.37-2.38-9.61s-1.54-6.48-3.31-9.3-4.57-5.17-7.92-5.76-7.16.94-8.51,3.96"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M163.09,432.64v3.71l-.25,55.62c0,6.46,5.68,11.63,12.8,11.61h0c7.2,0,13.15-5.32,13.28-11.88.15-6.85.43-14.05.43-14.05,0,0,9.12-1.31,11.22-12.79,1.04-5.7.91-15.09.56-22.77-.31-6.7-6.16-11.9-13.07-11.6-.18,0-.36.02-.54.03l-24.43,2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M198.35,449.15c0,.8-.67,1.45-1.5,1.47-.79.05-1.48-.53-1.54-1.3,0-.02,0-.04,0-.07,0-.8.67-1.45,1.49-1.46.79-.06,1.49.52,1.55,1.29,0,.02,0,.04,0,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M198.95,446.97c-.19.19-1.33-.66-2.97-.7s-2.88.75-3.03.55c-.09-.09.12-.43.64-.79.71-.47,1.56-.72,2.43-.7.85.01,1.67.29,2.36.78.5.41.66.76.57.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M182.84,448.85c0,.8-.67,1.45-1.5,1.46-.79.05-1.48-.53-1.54-1.3,0-.02,0-.04,0-.06,0-.8.67-1.45,1.49-1.47.79-.06,1.49.52,1.54,1.29,0,.02,0,.05,0,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M182.85,446.98c-.19.19-1.33-.66-2.97-.7s-2.88.75-3.03.55c-.09-.09.12-.43.64-.8.72-.47,1.56-.71,2.43-.7.85,0,1.68.28,2.36.78.49.43.66.78.56.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M188.57,458.87c.87-.25,1.76-.39,2.67-.43.42,0,.82-.1.89-.38.04-.42-.05-.84-.25-1.21-.38-.99-.77-2.03-1.18-3.11-1.64-4.43-2.82-8.06-2.63-8.13s1.66,3.49,3.29,7.9l1.13,3.12c.25.5.32,1.06.19,1.6-.13.29-.4.51-.72.58-.24.05-.48.08-.72.08-.89.09-1.78.07-2.67-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M189.36,477.67c-5.6,0-11.09-1.53-15.85-4.39,0,0,3.71,7.97,15.6,7.1l.24-2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M187.81,462.68c-.62-.79-1.61-1.21-2.62-1.11-.73.05-1.41.39-1.88.94-.46.53-.52,1.29-.17,1.89.53.6,1.39.83,2.16.57.78-.25,1.5-.65,2.12-1.17.19-.12.35-.28.48-.46.12-.18.12-.41,0-.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M183.73,459.88c.27,0,.24,1.71,1.74,2.96s3.39,1.09,3.4,1.33c0,.1-.42.33-1.22.34-1.04,0-2.05-.36-2.85-1.02-.76-.62-1.25-1.52-1.34-2.48-.06-.68.15-1.15.27-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M183.39,440.76c-.17.43-1.8.2-3.72.38-1.92.19-3.49.7-3.74.28-.11-.19.17-.59.8-.99.84-.51,1.79-.82,2.78-.89.98-.09,1.96.04,2.88.38.72.29,1.07.64,1,.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M198.43,442.36c-.3.36-1.44-.03-2.77-.08s-2.51.2-2.77-.18c-.11-.19.08-.54.58-.88,1.4-.82,3.16-.73,4.47.22.47.38.62.73.49.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M177.96,428.89c3.21,4.06,0,9.87-3.64,13.6-3.64,3.73-8.02,8.05-6.97,13.06,1.22,5.81,9.46,9.47,8.31,15.29-.42,2.1-2.16,3.95-2.12,6.11,0,3.91,5.26,5.76,6.79,9.36,2.1,4.95-3.49,9.96-3.53,15.32,0,3.04,1.79,5.85,1.92,8.89.25,6.23-7.29,10.85-13.53,9.38-6.24-1.47-10.57-7.36-11.98-13.46s-.48-12.41.46-18.56c-.6,2.63-4.7,3.16-6.73,1.32s-2.3-4.89-1.87-7.54c1.07-6.67,5.52-12.35,7.6-18.79,1.82-5.63,1.77-11.64,2.54-17.47s2.56-11.96,7.13-15.86,12.52-4.45,16.29.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M161.7,517.62c.05-.08.1-.16.15-.23.11-.16.26-.38.45-.66,1.44-2.22,2.25-4.77,2.33-7.39.09-2.11-.31-4.22-1.17-6.17-.94-2.17-2.61-4.19-4.37-6.4-.93-1.13-1.78-2.31-2.54-3.55-.8-1.32-1.37-2.75-1.69-4.25-.35-1.61-.21-3.28.4-4.81.34-.78.83-1.49,1.44-2.1.63-.59,1.31-1.14,2.04-1.62,1.44-.99,2.88-1.99,3.7-3.54.73-1.61.84-3.41.33-5.09-.86-3.49-3.37-6.22-4.98-9.26-.85-1.48-1.36-3.13-1.49-4.83-.07-1.63.25-3.26.93-4.75,1.32-2.69,3.22-5.08,5.58-6.99,2.16-1.87,4.25-3.45,5.99-5.1,1.6-1.44,2.94-3.13,3.95-5.01.76-1.42,1.22-2.97,1.35-4.57.08-1.01-.02-2.02-.31-2.99-.2-.7-.37-.99-.35-1.01.17.31.31.64.42.99.32.97.45,2,.38,3.02-.11,1.62-.55,3.2-1.31,4.65-1,1.91-2.34,3.64-3.95,5.11-1.74,1.68-3.85,3.28-5.96,5.14-2.32,1.9-4.18,4.27-5.47,6.93-.66,1.45-.96,3.02-.89,4.6.13,1.64.62,3.24,1.44,4.68.81,1.5,1.81,2.93,2.76,4.43,1.01,1.51,1.78,3.16,2.26,4.89.53,1.77.41,3.66-.36,5.34-.84,1.66-2.42,2.69-3.82,3.67-.71.47-1.38,1-2,1.58-.59.57-1.06,1.24-1.4,1.98-.59,1.47-.72,3.07-.39,4.62.31,1.47.86,2.89,1.63,4.19.76,1.22,1.6,2.38,2.51,3.49,1.74,2.19,3.41,4.27,4.36,6.48.86,1.99,1.25,4.14,1.13,6.29-.11,2.65-.97,5.21-2.48,7.42-.21.29-.38.49-.49.64-.04.06-.09.12-.14.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M250.03,530.82l-27.3,46.24-38.66,1.3v4.12h112.94l30.74-48.84c.8-1.34.32-3.05-1.05-3.82-.42-.24-.9-.37-1.39-.37h-72.79c-1.02,0-1.96.52-2.48,1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M284.22,555.51c-1.71,2.59-4.32,3.91-5.89,2.94s-1.4-3.84.31-6.42,4.32-3.91,5.89-2.94,1.4,3.84-.31,6.42Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M420.42,561.63c-.04-.12-.09-.24-.16-.36l-.5-1.03c-.6-1.34-1.08-2.72-1.44-4.13-.97-3.68-1.3-9.29.13-15.96.77-3.63,1.79-7.21,3.05-10.72,1.3-3.81,2.79-7.85,4.02-12.21,1.38-4.55,2.05-9.28,1.98-14.03-.18-4.96-1.7-9.91-3.36-14.85s-3.38-9.78-3.9-14.62c-.57-4.68.4-9.41,2.77-13.51,2.2-3.94,4.98-7.31,7.05-10.8,1.94-3.24,3.37-6.74,4.24-10.38,1.25-5.28,1.34-10.75.27-16.07-.38-1.95-.96-3.85-1.73-5.69.02.13.06.25.1.38.09.27.2.64.35,1.09.43,1.4.79,2.82,1.07,4.25.99,5.29.84,10.73-.43,15.96-.89,3.6-2.32,7.06-4.25,10.25-2.07,3.45-4.86,6.81-7.11,10.79-2.44,4.18-3.45,9.01-2.88,13.78.52,4.94,2.25,9.78,3.9,14.74,1.66,4.95,3.16,9.82,3.36,14.71.07,4.7-.58,9.37-1.94,13.88-1.2,4.35-2.69,8.38-3.96,12.2-1.24,3.53-2.25,7.13-3,10.78-1.4,6.71-1,12.39.04,16.07.39,1.42.92,2.8,1.57,4.12l.55,1.01c.05.12.12.23.2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M427.22,452.86s4.21-13.07-3.35-20.73c-.17-.18-.46-.2-.65-.04-.08.07-.13.16-.15.26-.4,2.16-.91,8.73,4.15,20.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M424.69,436.49c.01.81.11,1.62.29,2.42.27,1.66.6,3.61.96,5.76s.67,4.11.94,5.77c.07.81.22,1.6.45,2.38.08-.81.06-1.63-.07-2.43-.14-1.5-.41-3.55-.8-5.81s-.79-4.28-1.11-5.75c-.13-.8-.35-1.59-.66-2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M422.3,483.7s-2.58-13.47-12.97-16.77c-.24-.09-.5.03-.59.26-.04.09-.04.2,0,.29.66,2.05,3.39,8.1,13.56,16.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M412.13,470.38c.41.71.89,1.38,1.44,2,1.04,1.35,2.27,2.92,3.6,4.66l3.6,4.67c.46.68.97,1.32,1.55,1.91-.32-.74-.74-1.45-1.24-2.1-.84-1.26-2.07-2.95-3.5-4.77s-2.76-3.43-3.76-4.58c-.49-.66-1.06-1.26-1.69-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M425.07,517.5s1.56-13.62-7.37-19.73c-.22-.14-.51-.07-.65.14-.04.07-.07.15-.07.23,0,2.2.81,8.75,8.09,19.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M419.37,501.89c.18.79.43,1.57.77,2.31.6,1.59,1.3,3.44,2.07,5.48s1.44,3.91,2.06,5.49c.23.78.54,1.53.91,2.26-.08-.81-.26-1.6-.55-2.37-.43-1.45-1.1-3.41-1.92-5.59s-1.61-4.07-2.23-5.44c-.29-.75-.66-1.47-1.12-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M417.25,551.49s1.07-13.67-8.08-19.47c-.22-.14-.51-.07-.65.14-.05.08-.08.16-.07.25.09,2.19,1.13,8.71,8.8,19.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M410.98,536.09c.19.79.47,1.55.84,2.28l2.28,5.41c.85,2.03,1.61,3.86,2.26,5.41.26.77.59,1.52.99,2.23-.12-.81-.33-1.6-.64-2.35-.48-1.4-1.22-3.37-2.12-5.48s-1.76-4-2.42-5.35c-.31-.75-.71-1.47-1.18-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M433.27,441.38s12.52-6.34,12.76-16.94c0-.25-.2-.46-.46-.46-.09,0-.18.02-.26.07-1.87,1.24-7.02,5.54-12.04,17.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M443.44,428.07c-.58.58-1.11,1.22-1.56,1.9-1.02,1.36-2.21,2.96-3.53,4.73s-2.52,3.37-3.54,4.72c-.54.62-1.02,1.29-1.44,1.99.65-.52,1.23-1.11,1.72-1.77.99-1.15,2.3-2.79,3.67-4.65,1.38-1.85,2.57-3.56,3.41-4.83.5-.65.93-1.36,1.27-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M419.83,469.46s12.89-5.59,13.81-16.16c.03-.25-.15-.47-.41-.5-.11-.01-.22.01-.31.07-1.92,1.17-7.34,5.13-13.09,16.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M430.81,456.78c-.62.54-1.19,1.15-1.68,1.8l-3.82,4.51-3.83,4.51c-.58.59-1.1,1.23-1.55,1.91.67-.49,1.29-1.05,1.83-1.67,1.06-1.09,2.47-2.65,3.96-4.42s2.79-3.41,3.7-4.62c.54-.62,1-1.3,1.38-2.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M427.25,500.78s8.85-10.68,4.7-20.48c-.1-.23-.37-.35-.61-.25-.09.04-.17.1-.22.18-1.19,1.87-4.14,7.81-3.88,20.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M431.07,484.65c-.29.76-.51,1.55-.65,2.35-.37,1.64-.8,3.57-1.27,5.71s-.92,4.06-1.3,5.7c-.23.78-.39,1.57-.48,2.38.38-.73.66-1.49.84-2.28.43-1.44.96-3.45,1.44-5.69s.88-4.27,1.12-5.75c.19-.79.29-1.6.3-2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M418.48,537.64s12.79-5.8,13.52-16.38c.03-.25-.16-.47-.42-.5-.11-.01-.21.01-.3.07-1.91,1.17-7.25,5.25-12.8,16.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M429.24,524.79c-.61.56-1.16,1.17-1.65,1.83l-3.74,4.58-3.72,4.58c-.57.6-1.07,1.25-1.51,1.94.67-.5,1.27-1.06,1.79-1.7,1.04-1.1,2.43-2.69,3.89-4.49s2.73-3.45,3.6-4.67c.52-.64.97-1.34,1.33-2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M393,483.78v1.17c.04.82.09,1.94.15,3.33.16,2.92.39,6.99.67,11.88h0c.91,4.95,3.52,10.48,7.02,15.78,2.56,3.93,5.25,7.5,7.57,10.83,2.11,2.9,4,5.93,5.68,9.08,1.1,2.14,1.99,4.38,2.66,6.68.22.82.39,1.45.49,1.89.04.22.1.44.19.66,0-.23-.04-.47-.09-.7-.06-.45-.19-1.1-.4-1.93-.6-2.34-1.44-4.61-2.51-6.78-1.63-3.2-3.51-6.28-5.61-9.21-2.3-3.35-4.98-6.92-7.53-10.84-3.48-5.31-6.07-10.72-7.02-15.59h0c-.35-4.89-.64-8.94-.86-11.88-.12-1.4-.21-2.49-.27-3.31,0-.35-.06-.64-.09-.87,0-.06-.02-.13-.04-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M400.61,514.93s-5.42-12.65,1.4-20.96c.16-.2.45-.24.66-.08.08.06.14.14.16.24.61,2.14,1.72,8.64-2.22,20.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M401.6,498.4c-.23.78-.38,1.58-.42,2.4-.19,1.49-.41,3.55-.58,5.83s-.24,4.35-.24,5.85c-.05.81,0,1.63.15,2.43.15-.8.22-1.61.22-2.42.12-1.68.25-3.65.4-5.83s.3-4.15.42-5.83c.11-.81.13-1.62.06-2.43Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400.61,514.93s-5.42-12.65,1.4-20.96c.16-.2.45-.24.66-.08.08.06.14.14.16.24.61,2.14,1.72,8.64-2.22,20.81Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M417.4,545.42s-4.32-13.04,3.14-20.76c.17-.19.47-.2.66-.03.07.07.13.15.15.25.42,2.15.99,8.73-3.95,20.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M419.76,529.03c-.3.76-.51,1.55-.63,2.35-.32,1.47-.72,3.49-1.06,5.76s-.61,4.32-.72,5.81c-.12.81-.13,1.62-.05,2.43.22-.78.36-1.58.42-2.39.25-1.66.55-3.62.89-5.77s.65-4.12.91-5.78c.16-.8.24-1.61.24-2.42Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417.4,545.42s-4.32-13.04,3.14-20.76c.17-.19.47-.2.66-.03.07.07.13.15.15.25.42,2.15.99,8.73-3.95,20.54Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M393.71,499.45s-11.57-7.85-10.4-18.4c.02-.25.25-.44.51-.41.1,0,.2.05.27.11,1.68,1.5,6.22,6.41,9.62,18.7Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.71,499.45s-11.57-7.85-10.4-18.4c.02-.25.25-.44.51-.41.1,0,.2.05.27.11,1.68,1.5,6.22,6.41,9.62,18.7Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M385.4,485.01c.23.78.55,1.53.96,2.24.66,1.36,1.62,3.21,2.74,5.22s2.16,3.8,3.03,5.07c.41.71.9,1.37,1.48,1.97-.32-.75-.7-1.47-1.15-2.15l-2.88-5.13-2.88-5.14c-.35-.73-.78-1.43-1.28-2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M412.73,532.5s-13.96-2.1-17.7-12.07c-.09-.24.04-.5.28-.58.09-.03.19-.04.28-.01,2.21.58,8.49,3.07,17.14,12.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.73,532.5s-13.96-2.1-17.7-12.07c-.09-.24.04-.5.28-.58.09-.03.19-.04.28-.01,2.21.58,8.49,3.07,17.14,12.67Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M398.7,523.07c.57.6,1.2,1.14,1.89,1.6,1.2.94,2.88,2.19,4.83,3.49s3.7,2.47,5.04,3.26c.69.47,1.43.85,2.22,1.14-.63-.54-1.3-1.02-2.01-1.44l-4.93-3.35-4.91-3.39c-.66-.51-1.37-.95-2.12-1.31Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "429.24 557.41 425.24 582.88 409.25 582.85 403.87 557.41 429.24 557.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M406.21,567.22s.04.04.13.1.23.14.42.23c.56.27,1.17.44,1.79.52.99.13,1.99.04,2.94-.27,1.27-.39,2.38-1.17,3.16-2.23.43-.64.68-1.37.72-2.13.09-.87-.33-1.71-1.09-2.19-.86-.42-1.9-.34-2.68.21-.8.57-1.34,1.4-1.53,2.34-.21.94-.28,1.91-.2,2.88.05,1.01.27,2,.65,2.94.39.99,1.03,1.87,1.85,2.56.85.73,1.94,1.17,3.08,1.24,1.14.02,2.26-.29,3.21-.9.91-.56,1.72-1.27,2.38-2.1.69-.79,1.11-1.77,1.21-2.79.08-1.02-.34-2.02-1.14-2.7-.83-.59-1.94-.66-2.83-.17-.85.41-1.46,1.19-1.64,2.1-.25,1.62.56,3.22,2.02,4.03,1.18.62,2.55.81,3.86.54.97-.2,1.9-.55,2.74-1.05.53-.3,1.05-.64,1.54-1.01.18-.12.35-.26.5-.41-.19.1-.37.22-.55.34-.35.22-.87.57-1.57.94-.84.46-1.76.78-2.71.95-1.25.24-2.55.04-3.66-.57-1.33-.76-2.05-2.22-1.82-3.7.16-.79.69-1.46,1.44-1.81.76-.43,1.71-.38,2.41.14.69.6,1.05,1.47.97,2.37-.1.95-.49,1.84-1.13,2.56-.64.78-1.41,1.46-2.28,1.99-.88.56-1.9.85-2.95.84-1.04-.07-2.03-.48-2.81-1.15-.77-.65-1.37-1.47-1.74-2.4-.36-.89-.57-1.84-.63-2.79-.08-.92-.02-1.85.17-2.76.17-.84.65-1.59,1.35-2.1.66-.48,1.54-.56,2.28-.22.65.4,1.01,1.12.93,1.87-.04.71-.27,1.39-.66,1.98-.73,1.01-1.78,1.77-2.98,2.17-.89.29-1.84.38-2.77.28-.83-.1-1.64-.34-2.4-.7Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatures);
export default __webpack_public_path__ + "static/media/features.8b5da24a1fe28a8aa7699239ad7b94fe.svg";
export { ForwardRef as ReactComponent };